module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WMS = exports.StationPoint = exports.SitesPoint = exports.SingleStationPoint = exports.OSM = exports.KML = exports.Custom = exports.MapStyles = exports.PopupFactory = exports.Map = exports.Textarea = exports.Autocomplete = exports.DatePicker = exports.IChart = exports.TimeStackedBar = exports.Timeserie = exports.TimeBar = exports.StackedBar = exports.Plot = exports.Pie = exports.Line = exports.HorizontalStackedBar = exports.HorizontalBar = exports.BoxPlot = exports.Bar = exports.Area = exports.Input = exports.Table = exports.ToastrReducer = exports.ToastrAction = exports.Toastr = exports.WaitReducer = exports.WaitAction = exports.Wait = exports.Checkbox = exports.Select = undefined;

	var _Select = __webpack_require__(1);

	var _Select2 = _interopRequireDefault(_Select);

	var _Input = __webpack_require__(4);

	var _Input2 = _interopRequireDefault(_Input);

	var _Checkbox = __webpack_require__(6);

	var _Checkbox2 = _interopRequireDefault(_Checkbox);

	var _Wait = __webpack_require__(7);

	var _Wait2 = _interopRequireDefault(_Wait);

	var _WaitAction = __webpack_require__(10);

	var _WaitAction2 = _interopRequireDefault(_WaitAction);

	var _WaitReducer = __webpack_require__(12);

	var _WaitReducer2 = _interopRequireDefault(_WaitReducer);

	var _Toastr = __webpack_require__(13);

	var _Toastr2 = _interopRequireDefault(_Toastr);

	var _ToastrAction = __webpack_require__(14);

	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);

	var _ToastrReducer = __webpack_require__(17);

	var _ToastrReducer2 = _interopRequireDefault(_ToastrReducer);

	var _Table = __webpack_require__(18);

	var _Table2 = _interopRequireDefault(_Table);

	var _Area = __webpack_require__(35);

	var _Area2 = _interopRequireDefault(_Area);

	var _Bar = __webpack_require__(45);

	var _Bar2 = _interopRequireDefault(_Bar);

	var _HorizontalBar = __webpack_require__(49);

	var _HorizontalBar2 = _interopRequireDefault(_HorizontalBar);

	var _Pie = __webpack_require__(51);

	var _Pie2 = _interopRequireDefault(_Pie);

	var _TimeBar = __webpack_require__(53);

	var _TimeBar2 = _interopRequireDefault(_TimeBar);

	var _Timeserie = __webpack_require__(42);

	var _Timeserie2 = _interopRequireDefault(_Timeserie);

	var _Line = __webpack_require__(55);

	var _Line2 = _interopRequireDefault(_Line);

	var _Plot = __webpack_require__(57);

	var _Plot2 = _interopRequireDefault(_Plot);

	var _StackedBar = __webpack_require__(59);

	var _StackedBar2 = _interopRequireDefault(_StackedBar);

	var _HorizontalStackedBar = __webpack_require__(61);

	var _HorizontalStackedBar2 = _interopRequireDefault(_HorizontalStackedBar);

	var _TimeStackedBar = __webpack_require__(63);

	var _TimeStackedBar2 = _interopRequireDefault(_TimeStackedBar);

	var _BoxPlot = __webpack_require__(65);

	var _BoxPlot2 = _interopRequireDefault(_BoxPlot);

	var _IChart = __webpack_require__(68);

	var _IChart2 = _interopRequireDefault(_IChart);

	var _DatePicker = __webpack_require__(74);

	var _DatePicker2 = _interopRequireDefault(_DatePicker);

	var _Autocomplete = __webpack_require__(77);

	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

	var _Textarea = __webpack_require__(78);

	var _Textarea2 = _interopRequireDefault(_Textarea);

	var _Map = __webpack_require__(79);

	var _Map2 = _interopRequireDefault(_Map);

	var _PopupFactory = __webpack_require__(83);

	var _PopupFactory2 = _interopRequireDefault(_PopupFactory);

	var _MapStyles = __webpack_require__(84);

	var _MapStyles2 = _interopRequireDefault(_MapStyles);

	var _Custom = __webpack_require__(85);

	var _Custom2 = _interopRequireDefault(_Custom);

	var _KML = __webpack_require__(88);

	var _KML2 = _interopRequireDefault(_KML);

	var _OSM = __webpack_require__(90);

	var _OSM2 = _interopRequireDefault(_OSM);

	var _SingleStationPoint = __webpack_require__(91);

	var _SingleStationPoint2 = _interopRequireDefault(_SingleStationPoint);

	var _SitesPoint = __webpack_require__(92);

	var _SitesPoint2 = _interopRequireDefault(_SitesPoint);

	var _StationPoint = __webpack_require__(95);

	var _StationPoint2 = _interopRequireDefault(_StationPoint);

	var _WMS = __webpack_require__(96);

	var _WMS2 = _interopRequireDefault(_WMS);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.Select = _Select2.default;
	exports.Checkbox = _Checkbox2.default;
	exports.Wait = _Wait2.default;
	exports.WaitAction = _WaitAction2.default;
	exports.WaitReducer = _WaitReducer2.default;
	exports.Toastr = _Toastr2.default;
	exports.ToastrAction = _ToastrAction2.default;
	exports.ToastrReducer = _ToastrReducer2.default;
	exports.Table = _Table2.default;
	exports.Input = _Input2.default;
	exports.Area = _Area2.default;
	exports.Bar = _Bar2.default;
	exports.BoxPlot = _BoxPlot2.default;
	exports.HorizontalBar = _HorizontalBar2.default;
	exports.HorizontalStackedBar = _HorizontalStackedBar2.default;
	exports.Line = _Line2.default;
	exports.Pie = _Pie2.default;
	exports.Plot = _Plot2.default;
	exports.StackedBar = _StackedBar2.default;
	exports.TimeBar = _TimeBar2.default;
	exports.Timeserie = _Timeserie2.default;
	exports.TimeStackedBar = _TimeStackedBar2.default;
	exports.IChart = _IChart2.default;
	exports.DatePicker = _DatePicker2.default;
	exports.Autocomplete = _Autocomplete2.default;
	exports.Textarea = _Textarea2.default;
	exports.Map = _Map2.default;
	exports.PopupFactory = _PopupFactory2.default;
	exports.MapStyles = _MapStyles2.default;
	exports.Custom = _Custom2.default;
	exports.KML = _KML2.default;
	exports.OSM = _OSM2.default;
	exports.SingleStationPoint = _SingleStationPoint2.default;
	exports.SitesPoint = _SitesPoint2.default;
	exports.StationPoint = _StationPoint2.default;
	exports.WMS = _WMS2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Select = function (_Component) {
	    _inherits(Select, _Component);

	    function Select(props) {
	        _classCallCheck(this, Select);

	        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

	        _this.init = function () {
	            $('select').material_select();
	        };

	        _this.getDefaultValue = function () {
	            var defaultValue = _this.props.elements.find(function (el) {
	                return el.selected;
	            });
	            if (defaultValue) {
	                return defaultValue.value;
	            }
	            return null;
	        };

	        return _this;
	    }

	    _createClass(Select, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;

	            this.init();
	            $(this.selectRef).on('change', function () {
	                return _this2.props.onChange(_this2.selectRef.value);
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.init();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;

	            var options = this.props.elements.map(function (el) {
	                var optionProps = {};
	                if (el.value == _this3.props.selected) {
	                    optionProps.selected = true;
	                }
	                if (el.disabled) {
	                    optionProps.disabled = 'disabled';
	                }
	                return _react2.default.createElement(
	                    'option',
	                    _extends({ value: el.value }, optionProps),
	                    el.label
	                );
	            });

	            var className = 'input-field no-margin-top ' + (this.props.className || '');

	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                    'select',
	                    { ref: function ref(_ref) {
	                            return _this3.selectRef = _ref;
	                        } },
	                    options
	                ),
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    this.props.label
	                )
	            );
	        }
	    }]);

	    return Select;
	}(_react.Component);

	Select.propTypes = {
	    elements: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        value: _propTypes2.default.string,
	        label: _propTypes2.default.string
	    })).isRequired,
	    className: _propTypes2.default.string,
	    onChange: _propTypes2.default.func.isRequired,
	    selected: _propTypes2.default.any,
	    label: _propTypes2.default.string
	};

	Select.defaultProps = {
	    label: ''
	};

	exports.default = Select;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = require("prop-types");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _uuid = __webpack_require__(5);

	var _uuid2 = _interopRequireDefault(_uuid);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Materialize = window.Materialize;

	var Input = function (_Component) {
	    _inherits(Input, _Component);

	    function Input(props) {
	        _classCallCheck(this, Input);

	        var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

	        _this.updateTextFields = function () {
	            if (Materialize.updateTextFields) {
	                Materialize.updateTextFields();
	            }
	        };

	        _this.changeValue = function (e) {
	            _this.setState({ value: e.target.value });
	        };

	        _this.getLabel = function () {
	            return _react2.default.createElement(
	                'label',
	                { htmlFor: _this.state.selectId },
	                _this.props.label
	            );
	        };

	        _this.getValue = function () {
	            return _this.inputRef.value;
	        };

	        _this.state = {
	            selectId: _uuid2.default.v4(),
	            value: ''
	        };
	        return _this;
	    }

	    _createClass(Input, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ value: this.props.value });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.updateTextFields();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ value: nextProps.value });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.updateTextFields();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var className = 'input-field ' + (this.props.className || '');

	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement('input', { placeholder: this.props.placeholder, ref: function ref(_ref) {
	                        return _this2.inputRef = _ref;
	                    }, id: this.state.selectId, value: this.state.value, onChange: this.changeValue,
	                    type: this.props.type,
	                    className: 'validate' }),
	                this.getLabel()
	            );
	        }
	    }]);

	    return Input;
	}(_react.Component);

	Input.propTypes = {
	    type: _propTypes2.default.string.isRequired,
	    className: _propTypes2.default.string,
	    selectId: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    label: _propTypes2.default.string,
	    value: _propTypes2.default.string
	};

	Input.defaultProps = {
	    reference: '',
	    value: ''
	};

	exports.default = Input;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = require("uuid");

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _uuid = __webpack_require__(5);

	var _uuid2 = _interopRequireDefault(_uuid);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Checkbox = function (_Component) {
	    _inherits(Checkbox, _Component);

	    function Checkbox(props) {
	        _classCallCheck(this, Checkbox);

	        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

	        _this.getLabel = function () {
	            return _react2.default.createElement(
	                'label',
	                { htmlFor: _this.state.selectId },
	                _this.props.label
	            );
	        };

	        _this.getValue = function () {
	            return _this.state.checked;
	        };

	        _this.check = function () {
	            var checked = !_this.state.checked;
	            _this.setState({ checked: checked });
	            if (_this.props.onChange) {
	                _this.props.onChange(checked);
	            }
	        };

	        _this.getClassName = function () {
	            if (_this.props.condensed) {
	                return _this.props.condensed ? 'no-margin validate ' + (_this.props.className || '') : 'validate ' + (_this.props.className || '');
	            }
	            return 'validate';
	        };

	        _this.getInput = function () {
	            var inputClassName = _this.getClassName();
	            if (_this.props.disabled) {
	                return _react2.default.createElement('input', { placeholder: _this.props.placeholder, id: _this.state.selectId,
	                    type: 'checkbox', checked: _this.state.checked,
	                    className: inputClassName, onClick: _this.check, disabled: true });
	            }
	            return _react2.default.createElement('input', { placeholder: _this.props.placeholder, id: _this.state.selectId,
	                type: 'checkbox', checked: _this.state.checked,
	                className: inputClassName, onClick: _this.check });
	        };

	        _this.state = {
	            selectId: _uuid2.default.v4(),
	            checked: false
	        };
	        return _this;
	    }

	    _createClass(Checkbox, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ checked: this.props.checked });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ checked: nextProps.checked });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var condensedClass = this.props.condensed ? 'no-margin ' + (this.props.className || '') : this.props.className || '';
	            return _react2.default.createElement(
	                'div',
	                { className: condensedClass ? condensedClass : this.props.className || '' },
	                this.getInput(),
	                this.getLabel()
	            );
	        }
	    }]);

	    return Checkbox;
	}(_react.Component);

	Checkbox.propTypes = {
	    className: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    placeholder: _propTypes2.default.string,
	    label: _propTypes2.default.string,
	    checked: _propTypes2.default.bool.isRequired,
	    condensed: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool
	};

	Checkbox.defaultProps = {
	    checked: false,
	    className: '',
	    label: '',
	    placeholder: '',
	    onChange: function onChange() {},
	    condensed: false,
	    disabled: false
	};

	exports.default = Checkbox;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _reactRedux = __webpack_require__(8);

	var _reactSpinkit = __webpack_require__(9);

	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Wait = function (_React$Component) {
	    _inherits(Wait, _React$Component);

	    function Wait(props) {
	        _classCallCheck(this, Wait);

	        return _possibleConstructorReturn(this, (Wait.__proto__ || Object.getPrototypeOf(Wait)).call(this, props));
	    }

	    _createClass(Wait, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.isWait) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'bg-overlay' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wait' },
	                        _react2.default.createElement(_reactSpinkit2.default, { name: this.props.name, color: this.props.color, fadeIn: this.props.fadeIn })
	                    )
	                );
	            }
	            return null;
	        }
	    }]);

	    return Wait;
	}(_react2.default.Component);

	Wait.defaultProps = {
	    name: 'ball-spin-fade-loader',
	    color: 'black',
	    fadeIn: 'none',
	    isWait: false
	};

	Wait.propTypes = {
	    name: _propTypes2.default.string,
	    color: _propTypes2.default.string,
	    fadeIn: _propTypes2.default.string,
	    isWait: _propTypes2.default.bool
	};

	var mapStateToProps = function mapStateToProps(store) {
	    return {
	        isWait: store.WaitReducer.isWait,
	        name: store.WaitReducer.name,
	        color: store.WaitReducer.color,
	        fadeIn: store.WaitReducer.fadeIn
	    };
	};

	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Wait);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = require("react-redux");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = require("react-spinkit");

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _WaitConstants = __webpack_require__(11);

	var AppAction = {
	    wait: function wait(display) {
	        return {
	            type: _WaitConstants.WAIT,
	            wait: display
	        };
	    },
	    waitStart: function waitStart() {
	        return AppAction.wait(true);
	    },
	    waitStop: function waitStop() {
	        return AppAction.wait(false);
	    }
	};

	exports.default = AppAction;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  WAIT: 'WAIT'
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WaitReducer;

	var _WaitConstants = __webpack_require__(11);

	function WaitReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];

	    switch (action.type) {
	        case _WaitConstants.WAIT:
	            {
	                return Object.assign({}, state, {
	                    isWait: action.wait
	                });
	            }
	        default:
	            return state;
	    }
	}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _reactRedux = __webpack_require__(8);

	var _ToastrAction = __webpack_require__(14);

	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);

	__webpack_require__(16);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var toastr = window.toastr;

	var Toastr = function (_Component) {
	    _inherits(Toastr, _Component);

	    function Toastr(props) {
	        _classCallCheck(this, Toastr);

	        return _possibleConstructorReturn(this, (Toastr.__proto__ || Object.getPrototypeOf(Toastr)).call(this, props));
	    }

	    _createClass(Toastr, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.error && this.props.error != prevProps.error) {
	                toastr.error(this.props.error);
	                this.props.store.dispatch(_ToastrAction2.default.error(''));
	            }
	            if (this.props.success && this.props.success != prevProps.success) {
	                toastr.success(this.props.success);
	                this.props.store.dispatch(_ToastrAction2.default.success(''));
	            }
	            if (this.props.warning && this.props.warning != prevProps.warning) {
	                toastr.warning(this.props.warning);
	                this.props.store.dispatch(_ToastrAction2.default.success(''));
	            }
	            if (this.props.info && this.props.info != prevProps.info) {
	                toastr.info(this.props.info);
	                this.props.store.dispatch(_ToastrAction2.default.info(''));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);

	    return Toastr;
	}(_react.Component);

	Toastr.propTypes = {
	    error: _propTypes2.default.string,
	    success: _propTypes2.default.string,
	    warning: _propTypes2.default.string,
	    info: _propTypes2.default.string,
	    store: _propTypes2.default.object.isRequired
	};

	var mapStateToProps = function mapStateToProps(store) {
	    return {
	        error: store.ToastrReducer.error,
	        success: store.ToastrReducer.success,
	        warning: store.ToastrReducer.warning,
	        info: store.ToastrReducer.info
	    };
	};

	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Toastr);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _ToastrConstants = __webpack_require__(15);

	var ToastrAction = {
	    error: function error(message) {
	        return {
	            type: _ToastrConstants.TOASTR_ERROR,
	            message: message
	        };
	    },
	    success: function success(message) {
	        return {
	            type: _ToastrConstants.TOASTR_SUCCESS,
	            message: message
	        };
	    },
	    warning: function warning(message) {
	        return {
	            type: _ToastrConstants.TOASTR_WARNING,
	            message: message
	        };
	    },
	    info: function info(message) {
	        return {
	            type: _ToastrConstants.TOASTR_INFO,
	            message: message
	        };
	    }
	};

	exports.default = ToastrAction;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	    TOASTR_ERROR: 'TOASTR_ERROR',
	    TOASTR_SUCCESS: 'TOASTR_SUCCESS',
	    TOASTR_WARNING: 'TOASTR_WARNING',
	    TOASTR_INFO: 'TOASTR_INFO'
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";

	$(document).ready(function () {
	    toastr.options = {
	        "closeButton": false,
	        "debug": false,
	        "newestOnTop": false,
	        "progressBar": false,
	        "positionClass": "toast-bottom-left",
	        "preventDuplicates": false,
	        "onclick": null,
	        "showDuration": "300",
	        "hideDuration": "1000",
	        "timeOut": "5000",
	        "extendedTimeOut": "1000",
	        "showEasing": "swing",
	        "hideEasing": "linear",
	        "showMethod": "slideDown",
	        "hideMethod": "slideUp"
	    };
	});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ToastrReducer;

	var _ToastrConstants = __webpack_require__(15);

	function ToastrReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];

	    switch (action.type) {
	        case _ToastrConstants.TOASTR_ERROR:
	            {
	                return Object.assign({}, state, {
	                    error: action.message
	                });
	            }
	        case _ToastrConstants.TOASTR_SUCCESS:
	            {
	                return Object.assign({}, state, {
	                    success: action.message
	                });
	            }
	        case _ToastrConstants.TOASTR_WARNING:
	            {
	                return Object.assign({}, state, {
	                    warning: action.message
	                });
	            }
	        case _ToastrConstants.TOASTR_INFO:
	            {
	                return Object.assign({}, state, {
	                    info: action.message
	                });
	            }
	        default:
	            return state;
	    }
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _TableBody = __webpack_require__(19);

	var _TableBody2 = _interopRequireDefault(_TableBody);

	var _TableBodyColor = __webpack_require__(22);

	var _TableBodyColor2 = _interopRequireDefault(_TableBodyColor);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _TableHeader = __webpack_require__(28);

	var _TableHeader2 = _interopRequireDefault(_TableHeader);

	var _TableFilter = __webpack_require__(30);

	var _TableFilter2 = _interopRequireDefault(_TableFilter);

	var _TablePagination = __webpack_require__(31);

	var _TablePagination2 = _interopRequireDefault(_TablePagination);

	var _lodash = __webpack_require__(20);

	var _MoreVert = __webpack_require__(32);

	var _MoreVert2 = _interopRequireDefault(_MoreVert);

	var _simpleReactI18n = __webpack_require__(29);

	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);

	var _Select = __webpack_require__(1);

	var _Select2 = _interopRequireDefault(_Select);

	var _table_fr = __webpack_require__(33);

	var _table_fr2 = _interopRequireDefault(_table_fr);

	var _table = __webpack_require__(34);

	var _table2 = _interopRequireDefault(_table);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	_simpleReactI18n2.default.addLang(_table_fr2.default, ['fr', 'FR']);
	_simpleReactI18n2.default.addLang(_table2.default, 'default');
	_simpleReactI18n2.default.init();

	var $ = window.$;

	var Table = function (_Component) {
	    _inherits(Table, _Component);

	    function Table(props) {
	        _classCallCheck(this, Table);

	        var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

	        _this.onSort = function (value) {
	            var sort = 'asc';
	            if (_this.state.sortColumn.sort === sort && _this.state.sortColumn.column === value) {
	                sort = 'desc';
	            }
	            _this.setState({ sortColumn: { column: value, sort: sort } });
	        };

	        _this.onFilter = function (e) {
	            _this.setState({ filter: e.target.value });
	        };

	        _this.changePage = function (page) {
	            _this.setState({ page: page });
	        };

	        _this.onChange = function (value) {
	            _this.setState({
	                checked: value
	            });
	        };

	        _this.changeNbPerPage = function (nbPerPage) {
	            _this.setState({ nbPerPage: nbPerPage });
	        };

	        _this.updateArrowIcon = function () {
	            if (_this.state.arrowIcon === 'keyboard_arrow_down') {
	                $('.collapsible').collapsible('open', 0);
	                _this.setState({ arrowIcon: 'keyboard_arrow_up' });
	            } else {
	                $('.collapsible').collapsible('close', 0);
	                _this.setState({ arrowIcon: 'keyboard_arrow_down' });
	            }
	        };

	        _this.getTableFilter = function () {
	            if (_this.props.searchable) {
	                return _react2.default.createElement(_TableFilter2.default, { onFilter: _this.onFilter });
	            }
	            return null;
	        };

	        _this.getTablePagination = function (data) {
	            if (_this.props.paging && _this.state.nbPerPage != -1) {
	                return _react2.default.createElement(_TablePagination2.default, { nbElement: data.length, index: _this.state.page,
	                    nbElementPerPage: _this.state.nbPerPage,
	                    onChangePage: _this.changePage });
	            }
	            return null;
	        };

	        _this.searchable = function () {
	            return function () {
	                if (_this.state.filter) {
	                    return (0, _lodash.filter)(_this.props.data, function (value) {
	                        return (0, _lodash.some)(_this.getValues(value), function (item) {
	                            var newItem = item + '';
	                            if (typeof item === 'string') {
	                                newItem = item.toLowerCase();
	                            } else if (item === undefined || item === null) {
	                                newItem = '';
	                            }
	                            return newItem.startsWith(_this.state.filter);
	                        });
	                    });
	                }
	                return _this.props.data;
	            }();
	        };

	        _this.onSubmit = function () {
	            var exportData = [];
	            for (var idx = 0; idx < _this.dataCheck.length; idx++) {
	                var dataLine = _this.dataCheck[idx];
	                if (_this.refs[idx].getValue()) {
	                    exportData.push(dataLine);
	                }
	            }
	            return exportData;
	        };

	        _this.getHeaders = function () {
	            if (_this.props.type.headers) {
	                return _this.props.type.headers;
	            }
	            return Object.keys(_this.props.type);
	        };

	        _this.state = {
	            sortColumn: { column: '', sort: '' },
	            filter: '',
	            page: 1,
	            nbPerPage: -1,
	            checked: false,
	            arrowIcon: 'keyboard_arrow_down'
	        };
	        return _this;
	    }

	    _createClass(Table, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var newState = {
	                datatable: this.props.data,
	                checked: this.props.checked
	            };
	            if (this.props.nbPerPageLabel && this.props.nbPerPageLabel.length > 0) {
	                newState.nbPerPage = this.props.nbPerPageLabel[0].value;
	            }
	            this.setState(newState);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            $('.collapsible').collapsible();
	        }
	    }, {
	        key: 'getValues',
	        value: function getValues(object) {
	            return Object.values(object);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            // Searchable
	            var data = this.searchable();
	            this.dataCheck = [];

	            var nbElement = function () {
	                var label = data.length + ' ' + _simpleReactI18n2.default.element;
	                if (data.length > 1) {
	                    label = label + 's';
	                }
	                return label;
	            }();

	            // Paging
	            var tablePagination = function () {
	                if (_this2.props.paging && data.length > _this2.props.nbPerPageLabel[0].value) {
	                    return _react2.default.createElement(_Select2.default, { elements: _this2.props.nbPerPageLabel, onChange: _this2.changeNbPerPage });
	                }
	                return null;
	            }();

	            var pagination = this.getTablePagination(data);

	            if (this.state.nbPerPage !== -1) {
	                data = (0, _lodash.slice)(data, (this.state.page - 1) * this.state.nbPerPage, this.state.page * this.state.nbPerPage);
	            }

	            // Sortable
	            if (this.state.sortColumn.column) {
	                data = (0, _lodash.sortBy)(data, this.state.sortColumn.column);
	                if (this.state.sortColumn.sort === 'desc') {
	                    (0, _lodash.reverse)(data);
	                }
	            }
	            var head = function (sortable) {
	                if (sortable) {
	                    var headers = _this2.getHeaders();
	                    var className = _this2.props.headerClass ? _this2.props.headerClass : '';
	                    return _react2.default.createElement(
	                        'thead',
	                        { className: className },
	                        _react2.default.createElement(_TableHeader2.default, { checked: _this2.state.checked, onChange: _this2.onChange, headers: headers,
	                            checkable: _this2.props.checkable, sortColumn: _this2.state.sortColumn,
	                            onSort: _this2.onSort, condensed: _this2.props.condensed })
	                    );
	                }
	                return '';
	            }(this.props.sortable);

	            // Body
	            var body = data.map(function (d, id) {
	                if (_this2.props.color) {
	                    return _react2.default.createElement(_TableBodyColor2.default, { data: d, key: id, editable: _this2.props.editable,
	                        link: _this2.props.link, subLink: _this2.props.subLink,
	                        condensed: _this2.props.condensed, store: _this2.props.store,
	                        headers: _this2.getHeaders() });
	                }
	                return _react2.default.createElement(_TableBody2.default, { data: d, key: id, ref: id, editable: _this2.props.editable, link: _this2.props.link,
	                    subLink: _this2.props.subLink, condensed: _this2.props.condensed,
	                    checked: _this2.state.checked, checkable: _this2.props.checkable,
	                    store: _this2.props.store, headers: _this2.getHeaders() });
	            });

	            this.dataCheck = data;

	            var moreVert = function () {
	                if (_this2.props.actions.length > 0) {
	                    return _react2.default.createElement(_MoreVert2.default, { links: _this2.props.actions, store: _this2.props.store });
	                }
	                return '';
	            }();

	            var titleShow = function () {
	                if (_this2.props.showTitle) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'activator col s6' },
	                        _this2.props.title,
	                        ' (',
	                        nbElement,
	                        ')',
	                        moreVert
	                    );
	                }
	                return null;
	            }();
	            return _react2.default.createElement(
	                'div',
	                { className: 'card ' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-title activator' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row no-margin' },
	                        titleShow,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col s5 right' },
	                            this.getTableFilter()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-content no-padding-top', style: { overflowX: 'auto' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dataTables_wrapper dt-material no-footer' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'table',
	                                {
	                                    className: 'col l12 highlight table row-border order-column dataTable no-footer responsive-table' },
	                                head,
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    body
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            tablePagination
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            pagination
	                        )
	                    )
	                )
	            );
	        }
	    }]);

	    return Table;
	}(_react.Component);

	Table.propTypes = {
	    icon: _react2.default.PropTypes.string,
	    data: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	    type: _react2.default.PropTypes.instanceOf(_react2.default.PropTypes.object),
	    title: _react2.default.PropTypes.string,
	    sortable: _react2.default.PropTypes.bool,
	    searchable: _react2.default.PropTypes.bool,
	    editable: _react2.default.PropTypes.bool,
	    paging: _react2.default.PropTypes.bool,
	    nbPerPageLabel: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.element),
	    link: _react2.default.PropTypes.string,
	    checkable: _react2.default.PropTypes.bool,
	    subLink: _react2.default.PropTypes.string,
	    condensed: _react2.default.PropTypes.bool,
	    actions: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	        href: _react2.default.PropTypes.string.isRequired,
	        color: _react2.default.PropTypes.string,
	        iconName: _react2.default.PropTypes.string.isRequired
	    })),
	    checked: _react2.default.PropTypes.bool,
	    color: _react2.default.PropTypes.bool,
	    showTitle: _react2.default.PropTypes.bool,
	    store: _react2.default.PropTypes.object.isRequired,
	    headerClass: _react2.default.PropTypes.string
	};

	Table.defaultProps = {
	    data: [],
	    sortable: false,
	    searchable: false,
	    editable: false,
	    paging: false,
	    nbPerPageLabel: [],
	    actions: [],
	    color: false,
	    condensed: false,
	    checkable: false,
	    showTitle: true,
	    checked: false
	};

	exports.default = Table;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _lodash = __webpack_require__(20);

	var _reactRouterRedux = __webpack_require__(21);

	var _Checkbox = __webpack_require__(6);

	var _Checkbox2 = _interopRequireDefault(_Checkbox);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TableBody = function (_Component) {
	    _inherits(TableBody, _Component);

	    function TableBody(props) {
	        _classCallCheck(this, TableBody);

	        var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));

	        _this.onClick = function (idx) {
	            _this.setState({ editableColumn: idx, width: _this.refs['col-' + idx].offsetWidth });
	        };

	        _this.onLink = function (id) {
	            if (_this.props.subLink) {
	                _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + _this.props.link + '/' + id + '/' + _this.props.subLink));
	            } else {
	                _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + _this.props.link + '/' + id));
	            }
	        };

	        _this.getValue = function () {
	            return _this.refs.checkbox.getValue();
	        };

	        _this.onBlur = function () {
	            _this.props.data[(0, _lodash.keys)(_this.props.data)[_this.state.editableColumn]] = _this.refs.inputRef.value;
	            _this.setState({ editableColumn: -1 });
	        };

	        _this.getCheck = function (properties) {
	            if (_this.props.checkable) {
	                return [].concat(['check'], properties);
	            }
	            return properties;
	        };

	        _this.getClassNameOnClick = function (editable) {
	            var classNameOnClick = editable ? 'clickable' : '';
	            if (_this.props.condensed) {
	                return 'table-body-condensed ' + classNameOnClick;
	            }
	            return classNameOnClick;
	        };

	        _this.getData = function (val) {
	            var type = _typeof(_this.props.data[val]);
	            switch (type) {
	                case 'boolean':
	                    return _react2.default.createElement(_Checkbox2.default, { checked: _this.props.data[val], condensed: _this.props.condensed, disabled: true });
	                default:
	                    return _this.props.data[val];
	            }
	        };

	        _this.getCell = function (editable, val, idx) {

	            return _react2.default.createElement(
	                'td',
	                { key: idx, ref: 'col-' + idx, onClick: editable,
	                    className: _this.getClassNameOnClick(editable) },
	                ' ',
	                _this.getData(val)
	            );
	        };

	        _this.state = {
	            editableColumn: -1,
	            width: 0
	        };
	        return _this;
	    }

	    _createClass(TableBody, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var properties = this.props.headers;

	            var check = this.getCheck(properties);

	            // Linkable
	            var link = function () {
	                if (_this2.props.link) {
	                    return function () {
	                        return _this2.onLink(_this2.props.data.id);
	                    };
	                }
	                return '';
	            }();

	            var rows = check.map(function (val) {
	                if (val === 'check') {
	                    if (_this2.props.condensed) {
	                        return _react2.default.createElement(
	                            'td',
	                            { className: 'table-body-condensed column-checkbox' },
	                            _react2.default.createElement(_Checkbox2.default, { checked: _this2.props.checked, condensed: _this2.props.condensed, ref: 'checkbox' })
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'td',
	                        { className: 'column-checkbox' },
	                        _react2.default.createElement(_Checkbox2.default, { checked: _this2.props.checked, ref: 'checkbox' })
	                    );
	                }

	                var idx = Object.keys(_this2.props.data).indexOf(val);
	                if (idx === _this2.state.editableColumn) {
	                    return _react2.default.createElement(
	                        'td',
	                        { key: idx, className: 'card col clickable',
	                            style: { position: 'absolute', width: _this2.state.width },
	                            onClick: link },
	                        _react2.default.createElement('input', { autoFocus: true, type: 'text', ref: 'inputRef', onBlur: _this2.onBlur,
	                            defaultValue: _this2.props.data[val] })
	                    );
	                }

	                // Editable
	                var editable = function () {
	                    if (_this2.props.editable) {
	                        return function () {
	                            return _this2.onClick(idx);
	                        };
	                    }
	                    return link;
	                }();
	                return _this2.getCell(editable, val, idx);
	            });

	            var className = function () {
	                if (link) {
	                    return 'bottomMargin10 clickable';
	                }
	                return 'bottomMargin10';
	            }();

	            return _react2.default.createElement(
	                'tr',
	                { className: className },
	                rows
	            );
	        }
	    }]);

	    return TableBody;
	}(_react.Component);

	TableBody.propTypes = {
	    data: _react.PropTypes.object.isRequired,
	    editable: _react2.default.PropTypes.bool,
	    link: _react.PropTypes.string,
	    subLink: _react.PropTypes.string,
	    condensed: _react.PropTypes.bool,
	    checkable: _react.PropTypes.bool,
	    store: _react.PropTypes.object.isRequired,
	    headers: _react2.default.PropTypes.arrayOf(_react.PropTypes.string)
	};

	TableBody.defaultProps = {
	    data: {},
	    editable: false,
	    condensed: false,
	    checkable: false,
	    link: '',
	    sublink: ''
	};

	exports.default = TableBody;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = require("lodash");

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = require("react-router-redux");

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _lodash = __webpack_require__(20);

	var _reactRouterRedux = __webpack_require__(21);

	var _AppStore = __webpack_require__(23);

	var _AppStore2 = _interopRequireDefault(_AppStore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TableBodyColor = function (_Component) {
	    _inherits(TableBodyColor, _Component);

	    function TableBodyColor(props) {
	        _classCallCheck(this, TableBodyColor);

	        var _this = _possibleConstructorReturn(this, (TableBodyColor.__proto__ || Object.getPrototypeOf(TableBodyColor)).call(this, props));

	        _this.onClick = function (idx) {
	            _this.setState({ editableColumn: idx, width: _this.refs['col-' + idx].offsetWidth });
	        };

	        _this.onLink = function (id) {
	            if (_this.props.subLink) {
	                _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + _this.props.link + '/' + id + '/' + _this.props.subLink));
	            } else {
	                _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + _this.props.link + '/' + id));
	            }
	        };

	        _this.onBlur = function () {
	            _this.props.data[(0, _lodash.keys)(_this.props.data)[_this.state.editableColumn]] = _this.refs.inputRef.value;
	            _this.setState({ editableColumn: -1 });
	        };

	        _this.state = {
	            editableColumn: -1,
	            width: 0
	        };
	        return _this;
	    }

	    _createClass(TableBodyColor, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var properties = this.props.headers;
	            var rows = properties.map(function (val, idx) {
	                if (idx === _this2.state.editableColumn) {
	                    return _react2.default.createElement(
	                        'td',
	                        { key: idx, className: 'card col', style: { position: 'absolute', width: _this2.state.width } },
	                        _react2.default.createElement('input', { autoFocus: true, type: 'text', ref: 'inputRef', onBlur: _this2.onBlur,
	                            defaultValue: _this2.props.data[val] })
	                    );
	                }

	                // Editable
	                var editable = function () {
	                    if (_this2.props.editable) {
	                        return function () {
	                            return _this2.onClick(idx);
	                        };
	                    }
	                    return '';
	                }();
	                var className = [];
	                className.push(_this2.props.data.color || _this2.props.data[val].color);
	                className.push((_this2.props.data.textColor || _this2.props.data[val].textColor) + '-text');
	                className.push(_this2.props.condensed ? 'table-body-condensed' : '');
	                var value = _this2.props.data[val].value || _this2.props.data[val];
	                return _react2.default.createElement(
	                    'td',
	                    { key: idx, ref: 'col-' + idx, onClick: editable, className: className.join(' '), style: { borderRadius: '0px' } },
	                    _react2.default.createElement(
	                        'span',
	                        {
	                            className: 'truncate' },
	                        value
	                    )
	                );
	            });

	            // Linkable
	            var link = function () {
	                if (_this2.props.link) {
	                    return function () {
	                        return _this2.onLink(_this2.props.data.id);
	                    };
	                }
	                return '';
	            }();

	            var className = function () {
	                if (link) {
	                    return 'bottomMargin10 clickable';
	                }
	                return 'bottomMargin10';
	            }();

	            return _react2.default.createElement(
	                'tr',
	                { className: className, onClick: link },
	                rows
	            );
	        }
	    }]);

	    return TableBodyColor;
	}(_react.Component);

	TableBodyColor.propTypes = {
	    data: _react.PropTypes.object.isRequired,
	    editable: _react2.default.PropTypes.bool,
	    link: _react.PropTypes.string,
	    subLink: _react.PropTypes.string,
	    condensed: _react2.default.PropTypes.bool,
	    store: _react2.default.PropTypes.object.isRequired,
	    headers: _react2.default.PropTypes.arrayOf(_react.PropTypes.string)
	};

	TableBodyColor.defaultProps = {
	    data: {},
	    editable: false,
	    condensed: false
	};

	exports.default = TableBodyColor;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _reduxThunk = __webpack_require__(24);

	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

	var _redux = __webpack_require__(25);

	var _reactRouterRedux = __webpack_require__(21);

	var _reactRouter = __webpack_require__(26);

	var _reduxLogger = __webpack_require__(27);

	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

	var _WaitReducer = __webpack_require__(12);

	var _WaitReducer2 = _interopRequireDefault(_WaitReducer);

	var _ToastrReducer = __webpack_require__(17);

	var _ToastrReducer2 = _interopRequireDefault(_ToastrReducer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var router = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory);
	var enhancer = (0, _redux.applyMiddleware)(_reduxThunk2.default, router, _reduxLogger2.default);

	var AppStore = (0, _redux.createStore)((0, _redux.combineReducers)({ WaitReducer: _WaitReducer2.default, ToastrReducer: _ToastrReducer2.default, routing: _reactRouterRedux.routerReducer }), {
	    WaitReducer: {
	        isWait: false,
	        name: 'ball-spin-fade-loader',
	        color: 'red',
	        fadeIn: 'none'
	    },
	    ToastrReducer: {
	        success: '',
	        error: '',
	        warning: '',
	        info: ''
	    }
	}, enhancer);

	exports.default = AppStore;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = require("redux-thunk");

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = require("redux");

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = require("react-router");

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = require("redux-logger");

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _simpleReactI18n = __webpack_require__(29);

	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);

	var _Checkbox = __webpack_require__(6);

	var _Checkbox2 = _interopRequireDefault(_Checkbox);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TableHeader = function (_Component) {
	    _inherits(TableHeader, _Component);

	    function TableHeader() {
	        _classCallCheck(this, TableHeader);

	        return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
	    }

	    _createClass(TableHeader, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var check = this.props.headers;
	            if (this.props.checkable) {
	                check = [].concat(['check'], this.props.headers);
	            }
	            var rows = check.map(function (header) {
	                if (header === 'check') {
	                    if (_this2.props.condensed) {
	                        return _react2.default.createElement(
	                            'th',
	                            { className: 'table-body-condensed column-checkbox' },
	                            _react2.default.createElement(_Checkbox2.default, { checked: _this2.props.checked, condensed: _this2.props.condensed,
	                                onChange: _this2.props.onChange })
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'th',
	                        { className: 'column-checkbox' },
	                        _react2.default.createElement(_Checkbox2.default, { checked: _this2.props.checked, onChange: _this2.props.onChange })
	                    );
	                }
	                var iconClass = function () {
	                    var icon = 'fa';
	                    if (header === _this2.props.sortColumn.column) {
	                        icon = icon + ' fa-sort-' + _this2.props.sortColumn.sort;
	                    } else {
	                        icon = icon + ' fa-sort';
	                    }
	                    icon = icon + ' color-grey';
	                    return icon;
	                }();

	                var name = /^[0-9A-Za-z]+$/.test(header) && _simpleReactI18n2.default[header] ? _simpleReactI18n2.default[header] : header;
	                if (_this2.props.condensed) {
	                    return _react2.default.createElement(
	                        'th',
	                        { key: header, onClick: function onClick() {
	                                return _this2.props.onSort(header);
	                            },
	                            className: 'clickable no-padding' },
	                        name,
	                        '\xA0',
	                        _react2.default.createElement('i', { className: iconClass, 'aria-hidden': 'true' })
	                    );
	                }
	                return _react2.default.createElement(
	                    'th',
	                    { key: header, onClick: function onClick() {
	                            return _this2.props.onSort(header);
	                        }, className: 'clickable' },
	                    name,
	                    '\xA0',
	                    _react2.default.createElement('i', { className: iconClass, 'aria-hidden': 'true' })
	                );
	            });
	            return _react2.default.createElement(
	                'tr',
	                null,
	                rows
	            );
	        }
	    }]);

	    return TableHeader;
	}(_react.Component);

	TableHeader.propTypes = {
	    headers: _react.PropTypes.arrayOf(_react2.default.PropTypes.string).isRequired,
	    onSort: _react.PropTypes.func,
	    checkable: _react.PropTypes.bool,
	    sortColumn: _react.PropTypes.shape({
	        column: _react2.default.PropTypes.string.isRequired,
	        sort: _react2.default.PropTypes.string.isRequired
	    }),
	    condensed: _react.PropTypes.bool
	};

	TableHeader.defaultProps = {
	    checkable: false,
	    condensed: false
	};

	exports.default = TableHeader;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = require("simple-react-i18n");

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TableFilter = function (_Component) {
	    _inherits(TableFilter, _Component);

	    function TableFilter() {
	        _classCallCheck(this, TableFilter);

	        return _possibleConstructorReturn(this, (TableFilter.__proto__ || Object.getPrototypeOf(TableFilter)).apply(this, arguments));
	    }

	    _createClass(TableFilter, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'dataTables_filter' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'well' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row no-padding no-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-field col s12 no-margin-top' },
	                            _react2.default.createElement('input', { type: 'text', className: 'validate form-control input-sm no-margin-bottom', placeholder: 'Rechercher', 'aria-controls': 'tableStationQualito',
	                                onChange: this.props.onFilter })
	                        )
	                    )
	                )
	            );
	        }
	    }]);

	    return TableFilter;
	}(_react.Component);

	TableFilter.propTypes = {
	    onFilter: _react.PropTypes.func
	};

	exports.default = TableFilter;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _lodash = __webpack_require__(20);

	var _Select = __webpack_require__(1);

	var _Select2 = _interopRequireDefault(_Select);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TablePagination = function (_Component) {
	    _inherits(TablePagination, _Component);

	    function TablePagination() {
	        var _ref;

	        var _temp, _this, _ret;

	        _classCallCheck(this, TablePagination);

	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }

	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TablePagination.__proto__ || Object.getPrototypeOf(TablePagination)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (value) {
	            _this.props.onChangePage(value);
	        }, _this.getRange = function (nbPages) {
	            if (nbPages < 5) {
	                return (0, _lodash.range)(1, nbPages + 1);
	            } else if (_this.props.index + (_this.props.displayPage - 1) >= nbPages) {
	                return (0, _lodash.range)(nbPages - (_this.props.displayPage - 1), nbPages + 1);
	            } else if (_this.props.index > _this.props.displayPage) {
	                return (0, _lodash.range)(_this.props.index - (_this.props.displayPage - 3), _this.props.index + 1);
	            }
	            return (0, _lodash.range)(1, _this.props.displayPage + 1);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }

	    _createClass(TablePagination, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var style = { marginRight: '0.5rem' };
	            var nbPages = Math.ceil(this.props.nbElement / this.props.nbElementPerPage);
	            if (nbPages != 1) {
	                var pagination = function () {
	                    if (_this2.props.nbElementPerPage !== -1) {
	                        return _this2.getRange(nbPages).map(function (idx) {
	                            if (_this2.props.index === idx) {
	                                return _react2.default.createElement(
	                                    'a',
	                                    { className: 'btn waves-effect waves-light disabled', style: style, 'aria-controls': 'tableStationQualito', disabled: 'disabled', key: idx },
	                                    idx
	                                );
	                            }
	                            return _react2.default.createElement(
	                                'a',
	                                { className: 'btn waves-effect waves-light', style: style, 'aria-controls': 'tableStationQualito', onClick: function onClick() {
	                                        return _this2.onClick(idx);
	                                    }, key: idx },
	                                idx
	                            );
	                        });
	                    }
	                    return [_react2.default.createElement(
	                        'a',
	                        { className: 'btn waves-effect waves-light disabled', style: style, 'aria-controls': 'tableStationQualito', disabled: 'disabled', key: 1 },
	                        '1'
	                    )];
	                }();

	                var previous = function () {
	                    if (nbPages < _this2.props.displayPage + 1) {
	                        return null;
	                    }
	                    if (_this2.props.index === 1) {
	                        return _react2.default.createElement(
	                            'a',
	                            { className: 'btn previous disabled', style: style, id: 'tableStationQualito_previous', 'aria-controls': 'tableStationQualito', disabled: true },
	                            '<'
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'btn previous', style: style, id: 'tableStationQualito_previous', 'aria-controls': 'tableStationQualito', onClick: function onClick() {
	                                return _this2.onClick(_this2.props.index - 1);
	                            } },
	                        '<'
	                    );
	                }();
	                var next = function () {
	                    if (nbPages < _this2.props.displayPage + 1) {
	                        return null;
	                    }
	                    if (_this2.props.index === nbPages) {
	                        return _react2.default.createElement(
	                            'a',
	                            { className: 'btn next disabled', style: style, id: 'tableStationQualito_next', 'aria-controls': 'tableStationQualito', disabled: true },
	                            '>'
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'btn next', style: style, id: 'tableStationQualito_next', 'aria-controls': 'tableStationQualito', onClick: function onClick() {
	                                return _this2.onClick(_this2.props.index + 1);
	                            } },
	                        '>'
	                    );
	                }();
	                var threeDotsNext = function () {
	                    if (nbPages != 1 && nbPages > _this2.props.displayPage && _this2.props.index !== nbPages && _this2.props.index + _this2.props.displayPage - 1 < nbPages) {
	                        return [_react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-flat no-hover', style: style },
	                            '...'
	                        ), _react2.default.createElement(
	                            'a',
	                            { className: 'btn waves-effect waves-light', style: style, 'aria-controls': 'tableStationQualito', onClick: function onClick() {
	                                    return _this2.onClick(nbPages);
	                                } },
	                            nbPages
	                        )];
	                    }
	                    return null;
	                }();
	                var threeDotsPrevious = function () {
	                    if (nbPages != 1 && _this2.props.index > _this2.props.displayPage) {
	                        return [_react2.default.createElement(
	                            'a',
	                            { className: 'btn waves-effect waves-light', style: style, 'aria-controls': 'tableStationQualito', onClick: function onClick() {
	                                    return _this2.onClick(1);
	                                } },
	                            1
	                        ), _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-flat no-hover', style: style },
	                            '...'
	                        )];
	                    }
	                    return null;
	                }();

	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dataTables_paginate paging_simple_numbers' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pagination' },
	                        previous,
	                        threeDotsPrevious,
	                        pagination,
	                        threeDotsNext,
	                        next
	                    )
	                );
	            } else {
	                return null;
	            }
	        }
	    }]);

	    return TablePagination;
	}(_react.Component);

	TablePagination.propTypes = {
	    index: _react.PropTypes.number.isRequired,
	    nbElement: _react.PropTypes.number.isRequired,
	    nbElementPerPage: _react.PropTypes.number.isRequired,
	    onChangePage: _react.PropTypes.func.isRequired
	};

	TablePagination.defaultProps = {
	    displayPage: 5
	};

	exports.default = TablePagination;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _reactRouterRedux = __webpack_require__(21);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var MoreVert = function (_Component) {
	    _inherits(MoreVert, _Component);

	    function MoreVert(props) {
	        _classCallCheck(this, MoreVert);

	        var _this = _possibleConstructorReturn(this, (MoreVert.__proto__ || Object.getPrototypeOf(MoreVert)).call(this, props));

	        _this.onClick = function (href) {
	            _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + href));
	        };

	        return _this;
	    }

	    _createClass(MoreVert, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var links = this.props.links.map(function (link) {
	                return _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { onClick: function onClick() {
	                                return _this2.onClick(link.href);
	                            }, className: 'btn-floating ' + link.color },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons' },
	                            link.iconName
	                        )
	                    )
	                );
	            });
	            return _react2.default.createElement(
	                'div',
	                { className: 'right fixed-action-btn horizontal btn-tab-action click-to-toggle' },
	                _react2.default.createElement(
	                    'a',
	                    null,
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'material-icons ' },
	                        'more_vert'
	                    )
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    links
	                )
	            );
	        }
	    }]);

	    return MoreVert;
	}(_react.Component);

	MoreVert.propTypes = {
	    links: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	        href: _react2.default.PropTypes.string.isRequired,
	        color: _react2.default.PropTypes.string,
	        iconName: _react2.default.PropTypes.string.isRequired
	    })).isRequired,
	    store: _react2.default.PropTypes.object.isRequired
	};

	MoreVert.defaultProps = {
	    links: []
	};

	exports.default = MoreVert;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = {"element":"Elément"}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = {"element":"Elément"}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _AreaChart = __webpack_require__(36);

	var _AreaChart2 = _interopRequireDefault(_AreaChart);

	var _Timeserie2 = __webpack_require__(42);

	var _Timeserie3 = _interopRequireDefault(_Timeserie2);

	var _lodash = __webpack_require__(20);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Area = function (_Timeserie) {
	    _inherits(Area, _Timeserie);

	    function Area() {
	        _classCallCheck(this, Area);

	        return _possibleConstructorReturn(this, (Area.__proto__ || Object.getPrototypeOf(Area)).apply(this, arguments));
	    }

	    _createClass(Area, [{
	        key: 'initYScale',
	        value: function initYScale(yData) {
	            return _get(Area.prototype.__proto__ || Object.getPrototypeOf(Area.prototype), 'initYScale', this).call(this, (0, _lodash.flatten)(yData));
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            if (this.data[0].y.length > 1) {
	                return 'arearange';
	            }
	            return _get(Area.prototype.__proto__ || Object.getPrototypeOf(Area.prototype), 'focus', this).call(this);
	        }
	    }, {
	        key: 'svg',
	        value: function svg(data) {
	            return _react2.default.createElement(_AreaChart2.default, { data: data, xScale: this.xScale, yScale: this.yScale, color: this.color, isDashStyle: this.isDashStyle(), plot: this.plot });
	        }
	    }]);

	    return Area;
	}(_Timeserie3.default);

	exports.default = Area;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _TimeserieChart2 = __webpack_require__(37);

	var _TimeserieChart3 = _interopRequireDefault(_TimeserieChart2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Area = function (_TimeserieChart) {
	    _inherits(Area, _TimeserieChart);

	    function Area() {
	        _classCallCheck(this, Area);

	        return _possibleConstructorReturn(this, (Area.__proto__ || Object.getPrototypeOf(Area)).apply(this, arguments));
	    }

	    _createClass(Area, [{
	        key: 'getSvg',
	        value: function getSvg() {
	            var _this2 = this;

	            var area = d3.area().x(function (d) {
	                return _this2.props.xScale(d.x);
	            }).y1(function (d) {
	                if (d.y.length > 1) {
	                    return _this2.props.yScale(d.y[1]);
	                }
	                return _this2.props.yScale(d.y);
	            }).y0(function (d) {
	                if (d.y.length > 1) {
	                    return _this2.props.yScale(d.y[0]);
	                }
	                return _this2.props.yScale(_this2.props.yScale.domain()[0]);
	            });
	            var dash = function () {
	                if (_this2.props.isDashStyle) {
	                    return '5';
	                }
	                return '0';
	            }();

	            return _react2.default.createElement('path', { d: area(this.props.data), stroke: this.props.color, fill: this.props.color, strokeDasharray: dash,
	                opacity: '0.3' });
	        }
	    }]);

	    return Area;
	}(_TimeserieChart3.default);

	exports.default = Area;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _UtilChart = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var Timeserie = function (_ISerie) {
	    _inherits(Timeserie, _ISerie);

	    function Timeserie() {
	        _classCallCheck(this, Timeserie);

	        return _possibleConstructorReturn(this, (Timeserie.__proto__ || Object.getPrototypeOf(Timeserie)).apply(this, arguments));
	    }

	    _createClass(Timeserie, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var plots = function () {
	                if (_this2.props.plot) {
	                    return _this2.props.data.map(function (d) {
	                        return (0, _UtilChart.getPlot)(_this2.props.plot, _this2.props.xScale(d.x), _this2.props.yScale(d.y), _this2.props.color);
	                    });
	                }
	                return null;
	            }();
	            return _react2.default.createElement(
	                'g',
	                null,
	                this.getSvg(),
	                plots
	            );
	        }
	    }, {
	        key: 'getSvg',
	        value: function getSvg() {
	            var _this3 = this;

	            var line = d3.line().x(function (d) {
	                return _this3.props.xScale(d.x);
	            }).y(function (d) {
	                return _this3.props.yScale(d.y);
	            });

	            var dash = function () {
	                if (_this3.props.isDashStyle) {
	                    return '5';
	                }
	                return '0';
	            }();

	            return _react2.default.createElement('path', { d: line(this.props.data), stroke: this.props.color, fill: 'none', strokeDasharray: dash });
	        }
	    }]);

	    return Timeserie;
	}(_ISerie3.default);

	exports.default = Timeserie;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ISerie = function (_Component) {
	    _inherits(ISerie, _Component);

	    function ISerie(props) {
	        _classCallCheck(this, ISerie);

	        return _possibleConstructorReturn(this, (ISerie.__proto__ || Object.getPrototypeOf(ISerie)).call(this, props));
	    }

	    return ISerie;
	}(_react.Component);

	ISerie.propTypes = {
	    data: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	        x: _react2.default.PropTypes.any.isRequired,
	        y: _react2.default.PropTypes.number.isRequired,
	        color: _react2.default.PropTypes.string
	    })).isRequired,
	    color: _react2.default.PropTypes.string,
	    style: _react2.default.PropTypes.string,
	    name: _react2.default.PropTypes.string
	};

	exports.default = ISerie;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = require("moment");

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.scalePointPosition = exports.getInvert = exports.getYAxis = exports.closest = exports.getPlot = exports.getMouse = exports.getDataPoint = undefined;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _lodash = __webpack_require__(20);

	var _Axis = __webpack_require__(41);

	var _Axis2 = _interopRequireDefault(_Axis);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var d3 = window.d3;

	var getDataPoint = function getDataPoint(point, scale, data, method) {
	    var m = method || 'x';

	    var i = function () {
	        if (scale.invert) {
	            var x0 = getInvert(scale, point, m);
	            var close = closest(data.map(function (d) {
	                return d[m];
	            }), x0);
	            return (0, _lodash.findIndex)(data, function (d) {
	                return d[m] == close;
	            });
	        }
	        return scalePointPosition(point, scale);
	    }();
	    var d0 = data[i];

	    var dataPoint = { point: point };
	    dataPoint.data = d0;
	    return dataPoint;
	};

	var scalePointPosition = function scalePointPosition(point, xScale) {
	    var xPos = point.x;
	    var domain = xScale.domain();
	    var range = xScale.range();
	    var rangePoints = d3.range(range[0], range[1], xScale.step());
	    return d3.bisect(rangePoints, xPos) - 1;
	};

	var getInvert = function getInvert(scale, point, method) {
	    var invertScale = scale.invert(point[method]);
	    if (_moment2.default.isDate(invertScale)) {
	        return (0, _moment2.default)(invertScale).valueOf();
	    }
	    return invertScale;
	};

	var closest = function closest(arr, closestTo) {
	    return arr.reduce(function (prev, curr) {
	        return Math.abs(curr - closestTo) < Math.abs(prev - closestTo) ? curr : prev;
	    });
	};

	var getMouse = function getMouse(e, chartId) {
	    var svg = document.getElementById(chartId);
	    var pt = svg.createSVGPoint();
	    pt.x = e.clientX;
	    pt.y = e.clientY;
	    return pt.matrixTransform(svg.getScreenCTM().inverse());
	};

	var getPlot = function getPlot(plot, x, y, color) {
	    var r = 4;
	    switch (plot) {
	        case 'round':
	            return _react2.default.createElement('circle', { r: r, cx: x, cy: y, fill: color });
	        case 'square':
	            return _react2.default.createElement('rect', { x: x - r, y: y - r, width: r * 2,
	                height: r * 2, fill: color });
	        case 'diamond':
	            return _react2.default.createElement('rect', { x: x - r, y: y - r, width: r * 2,
	                height: r * 2, fill: color, transform: 'rotate(45,' + x + ',' + y + ')' });
	        case 'triangle':
	            var size = r * 3;
	            var newX = x - r * 1.5;
	            var newY = y + r * 1.5;
	            return _react2.default.createElement('polygon', { points: newX + ' ' + newY + ', ' + (newX + size / 2) + ' ' + (newY - size) + ', ' + (newX + size) + ' ' + newY, fill: color });
	        default:
	            return _react2.default.createElement('circle', { r: r, cx: x, cy: y, fill: color });
	    }
	};

	var getYAxis = function getYAxis(yScale, width, widthPadding, position) {
	    switch (position) {
	        case 'right':
	            return _react2.default.createElement(_Axis2.default, { orient: d3.axisRight, scale: yScale, tickSizeInner: -width + widthPadding * 2,
	                translate: 'translate(' + (width - widthPadding) + ',' + 0 + ')', width: widthPadding, truncate: true });
	        case 'left':
	        default:
	            return _react2.default.createElement(_Axis2.default, { orient: d3.axisLeft, scale: yScale, tickSizeInner: -width + widthPadding * 2,
	                translate: 'translate(' + widthPadding + ',' + 0 + ')', width: widthPadding, truncate: true });
	    }
	};

	exports.getDataPoint = getDataPoint;
	exports.getMouse = getMouse;
	exports.getPlot = getPlot;
	exports.closest = closest;
	exports.getYAxis = getYAxis;
	exports.getInvert = getInvert;
	exports.scalePointPosition = scalePointPosition;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var Axis = function (_Component) {
	    _inherits(Axis, _Component);

	    function Axis() {
	        var _ref;

	        var _temp, _this, _ret;

	        _classCallCheck(this, Axis);

	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }

	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Axis.__proto__ || Object.getPrototypeOf(Axis)).call.apply(_ref, [this].concat(args))), _this), _this.truncate = function (text, width) {
	            var paddingWidth = width * 0.70;
	            text.each(function () {
	                var t = d3.select(this);
	                var word = t.text();
	                var size = t.node().getComputedTextLength();

	                while (size > paddingWidth) {
	                    t.text(t.text().slice(0, -1));
	                    size = t.node().getComputedTextLength();
	                }
	                if (word.length != t.text().length) {
	                    t.text(t.text() + '...');
	                }
	                d3.select(t.node().parentNode).append("title").text(word);
	            });
	        }, _this.renderAxis = function () {
	            var node = _this.refs.axis;
	            var axis = _this.props.orient().ticks(6).scale(_this.props.scale).tickSizeOuter(0);
	            if (_this.props.tickSizeInner) {
	                axis.tickSizeInner(_this.props.tickSizeInner);
	            }
	            d3.select(node).call(axis);
	            if (_this.props.truncate) {
	                d3.select(node).selectAll('.tick text').call(_this.truncate, _this.props.width);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }

	    _createClass(Axis, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.renderAxis();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.renderAxis();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('g', { className: 'axis', ref: 'axis', transform: this.props.translate });
	        }
	    }]);

	    return Axis;
	}(_react.Component);

	Axis.propTypes = {
	    orient: _react2.default.PropTypes.func,
	    translate: _react2.default.PropTypes.string,
	    scale: _react2.default.PropTypes.func,
	    tickSizeInner: _react2.default.PropTypes.number
	};

	exports.default = Axis;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Serie2 = __webpack_require__(43);

	var _Serie3 = _interopRequireDefault(_Serie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _UtilChart = __webpack_require__(40);

	var _TimeserieChart = __webpack_require__(37);

	var _TimeserieChart2 = _interopRequireDefault(_TimeserieChart);

	var _lodash = __webpack_require__(20);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var Timeserie = function (_Serie) {
	    _inherits(Timeserie, _Serie);

	    function Timeserie(obj) {
	        _classCallCheck(this, Timeserie);

	        var _this = _possibleConstructorReturn(this, (Timeserie.__proto__ || Object.getPrototypeOf(Timeserie)).call(this, obj));

	        _this.plot = obj.plot;
	        _this.nice = obj.nice;
	        return _this;
	    }

	    _createClass(Timeserie, [{
	        key: 'initXDomain',
	        value: function initXDomain(rangeMin, rangeMax) {
	            this.xDomain = d3.scaleTime().range([rangeMin, rangeMax]);
	            return this;
	        }
	    }, {
	        key: 'initXScale',
	        value: function initXScale(xData) {
	            this.xScale = this.xDomain.domain(d3.extent(xData));
	            if (this.nice) {
	                this.xScale.nice();
	            }
	            return this;
	        }
	    }, {
	        key: 'chunck',
	        value: function chunck() {
	            var data = [];
	            var copyData = (0, _lodash.sortBy)(this.data.slice(), ['x']);
	            while (copyData.length > 0) {
	                var array = function () {
	                    if (copyData[0].y !== null) {
	                        return (0, _lodash.takeWhile)(copyData, function (d) {
	                            return d.y !== null;
	                        });
	                    }
	                    return (0, _lodash.takeWhile)(copyData, function (d) {
	                        return d.y === null;
	                    });
	                }();
	                copyData.splice(0, array.length);
	                data.push(array);
	            }
	            return data.filter(function (d) {
	                return d[0].y !== null;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding) {
	            var _this2 = this;

	            var chunck = this.chunck();
	            return chunck.map(function (d) {
	                return _this2.svg(d);
	            });
	        }
	    }, {
	        key: 'svg',
	        value: function svg(data) {
	            return _react2.default.createElement(_TimeserieChart2.default, { data: data, xScale: this.xScale, yScale: this.yScale, color: this.color, isDashStyle: this.isDashStyle(), plot: this.plot });
	        }
	    }]);

	    return Timeserie;
	}(_Serie3.default);

	exports.default = Timeserie;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Focus = __webpack_require__(44);

	var _Focus2 = _interopRequireDefault(_Focus);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Serie = function () {

	    /*
	        Serie {
	            data[{
	                x:0,
	                y:1,
	            },
	            {
	                x:0,
	                y:1,
	            }],
	            color: 'black',
	            style: 'solid',
	            name:'test2'
	        }
	          Serie {
	            data[{
	                x:0,
	                y:1,
	            },
	            {
	                x:0,
	                y:1,
	                color:'white'
	            }],
	            color: 'black',
	            style: 'dash'
	        }
	    */
	    function Serie(obj) {
	        _classCallCheck(this, Serie);

	        if (!this.initXDomain) {
	            throw new Error('initXDomain is not defined');
	        }
	        if (!this.initXScale) {
	            throw new Error('initXScale is not defined');
	        }
	        this.data = obj.data;
	        this.color = obj.color || 'steelblue';
	        this.style = obj.style || 'solid';
	        this.name = obj.name;
	        this.yMin = obj.yMin;
	        this.yMax = obj.yMax;
	        this.yAxis = obj.yAxis;
	    }

	    _createClass(Serie, [{
	        key: 'isSolidStyle',
	        value: function isSolidStyle() {
	            return this.style === 'solid';
	        }
	    }, {
	        key: 'isDashStyle',
	        value: function isDashStyle() {
	            return this.style === 'dash';
	        }
	    }, {
	        key: 'initXScale',
	        value: function initXScale(xData) {
	            this.xScale = this.xDomain.domain(xData);
	            return this;
	        }
	    }, {
	        key: 'initYDomain',
	        value: function initYDomain(rangeMin, rangeMax) {
	            this.yDomain = d3.scaleLinear().range([rangeMin, rangeMax]);
	            return this;
	        }
	    }, {
	        key: 'initYScale',
	        value: function initYScale(yData) {
	            var domain = d3.extent(yData);
	            var dMin = domain[0];
	            var dMax = domain[1];
	            dMin = function () {
	                if (dMin < 0) {
	                    return dMin * 1.1;
	                }
	                return dMin * 0.9;
	            }();

	            dMax = function () {
	                if (dMax < 0) {
	                    return dMax * 0.9;
	                }
	                return dMax * 1.1;
	            }();
	            this.yScale = this.yDomain.domain([dMin, dMax]);
	            return this;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            return 'focus';
	        }
	    }]);

	    return Serie;
	}();

	exports.default = Serie;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _UtilChart = __webpack_require__(40);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _lodash = __webpack_require__(20);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Focus = function (_Component) {
	    _inherits(Focus, _Component);

	    function Focus(props) {
	        _classCallCheck(this, Focus);

	        var _this = _possibleConstructorReturn(this, (Focus.__proto__ || Object.getPrototypeOf(Focus)).call(this, props));

	        _this.findSerie = function (d) {
	            return _this.props.series.find(function (s) {
	                return s.data.find(function (data) {
	                    return data.x == d.x && data.y == d.y;
	                }) !== undefined;
	            });
	        };

	        _this.getDataPoint = function (points, mouse) {
	            if (points.length > 1) {
	                return (0, _lodash.minBy)(points.map(function (point) {
	                    var serie = _this.findSerie(point.data);
	                    var invert = (0, _UtilChart.getInvert)(serie.yScale, mouse, 'y');
	                    return {
	                        data: point.data,
	                        abs: Math.abs(point.data.y - invert)
	                    };
	                }), 'abs');
	            }
	            return points[0];
	        };

	        _this.setRectWidth = function (state) {
	            var text = d3.select(_this.refs.text);
	            text.text('x : ' + state.xValue);
	            var xWidth = text.node().getComputedTextLength();
	            text.text('y : ' + state.yValue);
	            var yWidth = text.node().getComputedTextLength();
	            state.rectWidth = d3.max([xWidth, yWidth]) + 15;
	        };

	        _this.setTransform = function (dataPoint, state) {
	            var xScale = dataPoint.xScale(dataPoint.data.x);
	            state.transform = 'translate(' + dataPoint.xScale(dataPoint.data.x) + ',' + dataPoint.yScale(state.yValue) + ')';
	            if (xScale + state.rectWidth > _this.props.width) {
	                state.transformRect = 'translate(' + (dataPoint.xScale(dataPoint.data.x) - state.rectWidth - 20) + ',' + dataPoint.yScale(state.yValue) + ')';
	            } else {
	                state.transformRect = state.transform;
	            }
	        };

	        _this.state = {
	            rectWidth: 150,
	            transformRect: '',
	            display: 'none',
	            transform: null,
	            colorFocus: '',
	            yValue: 'Y',
	            xValue: 'X'
	        };
	        return _this;
	    }

	    _createClass(Focus, [{
	        key: 'mouseOver',
	        value: function mouseOver(e) {
	            this.setState({ display: 'inline' });
	        }
	    }, {
	        key: 'mouseOut',
	        value: function mouseOut(e) {
	            this.setState({ display: 'none' });
	        }
	    }, {
	        key: 'mouseMove',
	        value: function mouseMove(e) {
	            var _this2 = this;

	            var mouse = (0, _UtilChart.getMouse)(e, this.props.chartId);

	            var seriesData = this.props.series.map(function (serie) {
	                return serie.data;
	            });

	            var points = seriesData.map(function (data) {
	                return (0, _UtilChart.getDataPoint)(mouse, _this2.props.series[0].xScale, data, 'x');
	            }).filter(function (p) {
	                return p.data !== undefined;
	            });

	            var dataPoint = this.getDataPoint(points, mouse);

	            var state = {};

	            if (dataPoint && dataPoint.data) {
	                var serie = this.findSerie(dataPoint.data);
	                dataPoint.xScale = serie.xScale;
	                dataPoint.yScale = serie.yScale;
	                this.getValues(dataPoint, state);
	                this.setRectWidth(state);
	                this.setTransform(dataPoint, state);
	                state.colorFocus = serie.color || 'steelblue';
	            }
	            this.setState(state);
	        }
	    }, {
	        key: 'getValues',
	        value: function getValues(dataPoint, state) {
	            var d = dataPoint.data;
	            var xValue = function () {
	                var date = (0, _moment2.default)(d.x);
	                if (date.isValid()) {
	                    return date.toDate().toLocaleDateString() + ' ' + date.toDate().toLocaleTimeString();
	                }
	                return d.x;
	            }();
	            state.xValue = xValue;
	            state.yValue = d.y;
	        }
	    }, {
	        key: 'getFocus',
	        value: function getFocus() {
	            return _react2.default.createElement(
	                'g',
	                { style: { display: this.state.display } },
	                _react2.default.createElement('circle', { r: 4.5, fill: this.state.colorFocus, transform: this.state.transform }),
	                _react2.default.createElement(
	                    'g',
	                    { transform: this.state.transformRect, className: 'focus' },
	                    _react2.default.createElement('rect', { x: 9, rx: 5, height: 50, width: this.state.rectWidth }),
	                    _react2.default.createElement(
	                        'text',
	                        null,
	                        _react2.default.createElement(
	                            'tspan',
	                            { ref: 'text', x: 15, y: 10, dy: '.35em' },
	                            'y : ' + this.state.yValue
	                        ),
	                        _react2.default.createElement(
	                            'tspan',
	                            { x: 15, y: 30, dy: '.35em' },
	                            'x : ' + this.state.xValue
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var focus = this.getFocus();

	            return _react2.default.createElement(
	                'g',
	                null,
	                focus
	            );
	        }
	    }]);

	    return Focus;
	}(_react.Component);

	exports.default = Focus;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Serie2 = __webpack_require__(43);

	var _Serie3 = _interopRequireDefault(_Serie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _BarChart = __webpack_require__(46);

	var _BarChart2 = _interopRequireDefault(_BarChart);

	var _ReverseBarChart = __webpack_require__(47);

	var _ReverseBarChart2 = _interopRequireDefault(_ReverseBarChart);

	var _PositiveNegativeBarChart = __webpack_require__(48);

	var _PositiveNegativeBarChart2 = _interopRequireDefault(_PositiveNegativeBarChart);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var Bar = function (_Serie) {
	    _inherits(Bar, _Serie);

	    function Bar() {
	        _classCallCheck(this, Bar);

	        return _possibleConstructorReturn(this, (Bar.__proto__ || Object.getPrototypeOf(Bar)).apply(this, arguments));
	    }

	    _createClass(Bar, [{
	        key: 'initXDomain',
	        value: function initXDomain(rangeMin, rangeMax) {
	            this.xDomain = d3.scaleBand().rangeRound([rangeMin, rangeMax]).padding(0.1);
	            return this;
	        }
	    }, {
	        key: 'initYScale',
	        value: function initYScale(yData, xData) {
	            var ydomainMax = d3.max(yData);
	            var ydomainMin = d3.min(yData);
	            return _get(Bar.prototype.__proto__ || Object.getPrototypeOf(Bar.prototype), 'initYScale', this).call(this, [this.yMin || ydomainMin, this.yMax || ydomainMax]);
	        }
	    }, {
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding) {
	            var minMax = d3.extent(this.data.map(function (d) {
	                return d.y;
	            }));
	            if (minMax[0] < 0 && minMax[1] <= 0) {
	                return _react2.default.createElement(_ReverseBarChart2.default, { data: this.data, xdomain: this.xDomain, yScale: this.yScale, color: this.color, height: height, heightPadding: heightPadding });
	            } else if (minMax[0] < 0 && minMax[1] > 0) {
	                return _react2.default.createElement(_PositiveNegativeBarChart2.default, { data: this.data, xdomain: this.xDomain, yScale: this.yScale, color: this.color, height: height, heightPadding: heightPadding });
	            }
	            return _react2.default.createElement(_BarChart2.default, { data: this.data, xdomain: this.xDomain, yScale: this.yScale, color: this.color, height: height, heightPadding: heightPadding });
	        }
	    }]);

	    return Bar;
	}(_Serie3.default);

	exports.default = Bar;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var BarChart = function (_ISerie) {
	    _inherits(BarChart, _ISerie);

	    function BarChart() {
	        _classCallCheck(this, BarChart);

	        return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).apply(this, arguments));
	    }

	    _createClass(BarChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var bars = this.props.data.map(function (d, i) {
	                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.x), y: _this2.props.yScale(d.y), width: _this2.props.xdomain.bandwidth(),
	                    height: _this2.props.height - _this2.props.yScale(d.y) - _this2.props.heightPadding, fill: d.color || _this2.props.color });
	            });

	            return _react2.default.createElement(
	                'g',
	                null,
	                bars
	            );
	        }
	    }]);

	    return BarChart;
	}(_ISerie3.default);

	exports.default = BarChart;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ReverseBarChart = function (_ISerie) {
	    _inherits(ReverseBarChart, _ISerie);

	    function ReverseBarChart() {
	        _classCallCheck(this, ReverseBarChart);

	        return _possibleConstructorReturn(this, (ReverseBarChart.__proto__ || Object.getPrototypeOf(ReverseBarChart)).apply(this, arguments));
	    }

	    _createClass(ReverseBarChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var bars = this.props.data.map(function (d, i) {
	                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.x), y: _this2.props.heightPadding, width: _this2.props.xdomain.bandwidth(),
	                    height: _this2.props.yScale(d.y) - _this2.props.heightPadding, fill: d.color || _this2.props.color });
	            });

	            return _react2.default.createElement(
	                'g',
	                null,
	                bars
	            );
	        }
	    }]);

	    return ReverseBarChart;
	}(_ISerie3.default);

	exports.default = ReverseBarChart;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var PositiveNegativeBarChart = function (_ISerie) {
	    _inherits(PositiveNegativeBarChart, _ISerie);

	    function PositiveNegativeBarChart() {
	        var _ref;

	        var _temp, _this, _ret;

	        _classCallCheck(this, PositiveNegativeBarChart);

	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }

	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PositiveNegativeBarChart.__proto__ || Object.getPrototypeOf(PositiveNegativeBarChart)).call.apply(_ref, [this].concat(args))), _this), _this.getChartMeasures = function (y) {
	            if (y < 0) {
	                return {
	                    height: _this.props.yScale(y) - _this.props.yScale(0),
	                    y: _this.props.yScale(0)
	                };
	            }
	            return {
	                height: _this.props.yScale(0) - _this.props.yScale(y),
	                y: _this.props.yScale(y)
	            };
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }

	    _createClass(PositiveNegativeBarChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var bars = this.props.data.map(function (d, i) {
	                var chartMeasures = _this2.getChartMeasures(d.y);
	                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.x), y: chartMeasures.y, width: _this2.props.xdomain.bandwidth(),
	                    height: chartMeasures.height, fill: d.color || _this2.props.color });
	            });
	            return _react2.default.createElement(
	                'g',
	                null,
	                bars
	            );
	        }
	    }]);

	    return PositiveNegativeBarChart;
	}(_ISerie3.default);

	exports.default = PositiveNegativeBarChart;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Serie2 = __webpack_require__(43);

	var _Serie3 = _interopRequireDefault(_Serie2);

	var _HorizontalBarChart = __webpack_require__(50);

	var _HorizontalBarChart2 = _interopRequireDefault(_HorizontalBarChart);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var HorizontalBar = function (_Serie) {
	    _inherits(HorizontalBar, _Serie);

	    function HorizontalBar() {
	        _classCallCheck(this, HorizontalBar);

	        return _possibleConstructorReturn(this, (HorizontalBar.__proto__ || Object.getPrototypeOf(HorizontalBar)).apply(this, arguments));
	    }

	    _createClass(HorizontalBar, [{
	        key: 'initXDomain',
	        value: function initXDomain(rangeMin, rangeMax) {
	            this.xDomain = d3.scaleLinear().range([rangeMin, rangeMax]);
	            return this;
	        }
	    }, {
	        key: 'initXScale',
	        value: function initXScale(xData, yData) {
	            var xdomainMax = d3.max(yData);
	            var xdomainMin = d3.min(yData);
	            if (xdomainMin && xdomainMin < 0) {
	                xdomainMax = xdomainMin;
	            }
	            var dMax = function () {
	                if (xdomainMax < 0) {
	                    return xdomainMax * 0.9;
	                }
	                return xdomainMax * 1.1;
	            }();
	            this.xScale = this.xDomain.domain([0, dMax]).nice();
	            return this;
	        }
	    }, {
	        key: 'initYDomain',
	        value: function initYDomain(rangeMin, rangeMax) {
	            this.yDomain = d3.scaleBand().range([rangeMin, rangeMax]);
	            return this;
	        }
	    }, {
	        key: 'initYScale',
	        value: function initYScale(yData, xData) {
	            this.yScale = this.yDomain.domain(xData);
	            return this;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding) {
	            return _react2.default.createElement(_HorizontalBarChart2.default, { data: this.data, ydomain: this.yDomain, yScale: this.yScale, xScale: this.xScale, color: this.color, height: height, widthPadding: widthPadding });
	        }
	    }]);

	    return HorizontalBar;
	}(_Serie3.default);

	exports.default = HorizontalBar;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var HorizontalBarChart = function (_ISerie) {
	    _inherits(HorizontalBarChart, _ISerie);

	    function HorizontalBarChart() {
	        _classCallCheck(this, HorizontalBarChart);

	        return _possibleConstructorReturn(this, (HorizontalBarChart.__proto__ || Object.getPrototypeOf(HorizontalBarChart)).apply(this, arguments));
	    }

	    _createClass(HorizontalBarChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var bars = this.props.data.map(function (d, i) {
	                return _react2.default.createElement('rect', { x: _this2.props.widthPadding, y: _this2.props.yScale(d.x) + 10, width: _this2.props.xScale(d.y) - _this2.props.widthPadding,
	                    height: _this2.props.ydomain.bandwidth() - 15, fill: _this2.props.color });
	            });

	            return _react2.default.createElement(
	                'g',
	                null,
	                bars
	            );
	        }
	    }]);

	    return HorizontalBarChart;
	}(_ISerie3.default);

	exports.default = HorizontalBarChart;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Serie2 = __webpack_require__(43);

	var _Serie3 = _interopRequireDefault(_Serie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _PieChart = __webpack_require__(52);

	var _PieChart2 = _interopRequireDefault(_PieChart);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var Pie = function (_Serie) {
	    _inherits(Pie, _Serie);

	    function Pie() {
	        _classCallCheck(this, Pie);

	        return _possibleConstructorReturn(this, (Pie.__proto__ || Object.getPrototypeOf(Pie)).apply(this, arguments));
	    }

	    _createClass(Pie, [{
	        key: 'initXDomain',
	        value: function initXDomain() {
	            return this;
	        }
	    }, {
	        key: 'initXScale',
	        value: function initXScale() {
	            return this;
	        }
	    }, {
	        key: 'initYScale',
	        value: function initYScale() {
	            return this;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding) {
	            return _react2.default.createElement(_PieChart2.default, { data: this.data, width: width, height: height });
	        }
	    }]);

	    return Pie;
	}(_Serie3.default);

	exports.default = Pie;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var PieChart = function (_ISerie) {
	    _inherits(PieChart, _ISerie);

	    function PieChart(props) {
	        _classCallCheck(this, PieChart);

	        var _this = _possibleConstructorReturn(this, (PieChart.__proto__ || Object.getPrototypeOf(PieChart)).call(this, props));

	        _this.state = {
	            selected: ''
	        };
	        return _this;
	    }

	    _createClass(PieChart, [{
	        key: 'getElementData',
	        value: function getElementData(element) {
	            return element._groups[0][0].data;
	        }
	    }, {
	        key: 'mouseOver',
	        value: function mouseOver(el) {
	            this.setState({ selected: this.getElementData(el).x });
	        }
	    }, {
	        key: 'mouseOut',
	        value: function mouseOut() {
	            this.setState({ selected: '' });
	        }
	    }, {
	        key: 'getPath',
	        value: function getPath(data, radius) {
	            var _this2 = this;

	            return function () {
	                if (data.x == _this2.state.selected) {
	                    return d3.arc().outerRadius(radius).innerRadius(radius * 0.5);
	                }
	                return d3.arc().outerRadius(radius - 10).innerRadius(radius * 0.5);
	            }();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;

	            var radius = Math.min(this.props.width, this.props.height) / 2;

	            var arcs = d3.pie().value(function (d) {
	                return d.y;
	            })(this.props.data);
	            var arc = function () {
	                return arcs.map(function (d, i) {
	                    var path = _this3.getPath(d.data, radius);

	                    return _react2.default.createElement(
	                        'g',
	                        { onMouseOver: function onMouseOver() {
	                                return _this3.mouseOver(d3.select(d));
	                            },
	                            onMouseOut: function onMouseOut() {
	                                return _this3.mouseOut();
	                            } },
	                        _react2.default.createElement('path', { d: path(d), fill: d.data.color }),
	                        _react2.default.createElement(
	                            'text',
	                            { transform: 'translate(' + path.centroid(d) + ')', textAnchor: 'middle' },
	                            d.value
	                        )
	                    );
	                });
	                return '';
	            }();

	            return _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + this.props.width / 2 + ',' + this.props.height / 2 + ')' },
	                arc
	            );
	        }
	    }]);

	    return PieChart;
	}(_ISerie3.default);

	exports.default = PieChart;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Bar = __webpack_require__(45);

	var _Bar2 = _interopRequireDefault(_Bar);

	var _TimeBarChart = __webpack_require__(54);

	var _TimeBarChart2 = _interopRequireDefault(_TimeBarChart);

	var _Timeserie2 = __webpack_require__(42);

	var _Timeserie3 = _interopRequireDefault(_Timeserie2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var TimeBar = function (_Timeserie) {
	    _inherits(TimeBar, _Timeserie);

	    function TimeBar() {
	        _classCallCheck(this, TimeBar);

	        return _possibleConstructorReturn(this, (TimeBar.__proto__ || Object.getPrototypeOf(TimeBar)).apply(this, arguments));
	    }

	    _createClass(TimeBar, [{
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding) {
	            return _react2.default.createElement(_TimeBarChart2.default, { data: this.data, xdomain: this.xDomain, yScale: this.yScale, color: this.color, height: height, heightPadding: heightPadding });
	        }
	    }]);

	    return TimeBar;
	}(_Timeserie3.default);

	exports.default = TimeBar;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TimeBarChart = function (_ISerie) {
	    _inherits(TimeBarChart, _ISerie);

	    function TimeBarChart() {
	        _classCallCheck(this, TimeBarChart);

	        return _possibleConstructorReturn(this, (TimeBarChart.__proto__ || Object.getPrototypeOf(TimeBarChart)).apply(this, arguments));
	    }

	    _createClass(TimeBarChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var bars = this.props.data.map(function (d, i) {
	                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.x), y: _this2.props.yScale(d.y), width: 2,
	                    height: _this2.props.height - _this2.props.yScale(d.y) - _this2.props.heightPadding, fill: _this2.props.color });
	            });

	            return _react2.default.createElement(
	                'g',
	                null,
	                bars
	            );
	        }
	    }]);

	    return TimeBarChart;
	}(_ISerie3.default);

	exports.default = TimeBarChart;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Timeserie2 = __webpack_require__(42);

	var _Timeserie3 = _interopRequireDefault(_Timeserie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _LineChart = __webpack_require__(56);

	var _LineChart2 = _interopRequireDefault(_LineChart);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var Line = function (_Timeserie) {
	    _inherits(Line, _Timeserie);

	    function Line() {
	        _classCallCheck(this, Line);

	        return _possibleConstructorReturn(this, (Line.__proto__ || Object.getPrototypeOf(Line)).apply(this, arguments));
	    }

	    _createClass(Line, [{
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding) {
	            return _react2.default.createElement(_LineChart2.default, { data: this.data, yScale: this.yScale, color: this.color, width: width, widthPadding: widthPadding });
	        }
	    }]);

	    return Line;
	}(_Timeserie3.default);

	exports.default = Line;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _UtilChart = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var LineChart = function (_ISerie) {
	    _inherits(LineChart, _ISerie);

	    function LineChart() {
	        _classCallCheck(this, LineChart);

	        return _possibleConstructorReturn(this, (LineChart.__proto__ || Object.getPrototypeOf(LineChart)).apply(this, arguments));
	    }

	    _createClass(LineChart, [{
	        key: 'render',
	        value: function render() {
	            var y = this.props.yScale(this.props.data[0].y);
	            return _react2.default.createElement('line', { x1: this.props.widthPadding, y1: y, x2: this.props.width - this.props.widthPadding, y2: y, stroke: this.props.color, 'stroke-width': '5' });
	        }
	    }]);

	    return LineChart;
	}(_ISerie3.default);

	exports.default = LineChart;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _PlotChart = __webpack_require__(58);

	var _PlotChart2 = _interopRequireDefault(_PlotChart);

	var _Timeserie2 = __webpack_require__(42);

	var _Timeserie3 = _interopRequireDefault(_Timeserie2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Plot = function (_Timeserie) {
	    _inherits(Plot, _Timeserie);

	    function Plot() {
	        _classCallCheck(this, Plot);

	        return _possibleConstructorReturn(this, (Plot.__proto__ || Object.getPrototypeOf(Plot)).apply(this, arguments));
	    }

	    _createClass(Plot, [{
	        key: 'svg',
	        value: function svg(data) {
	            return _react2.default.createElement(_PlotChart2.default, { data: data, xScale: this.xScale, yScale: this.yScale, color: this.color, plot: this.plot });
	        }
	    }]);

	    return Plot;
	}(_Timeserie3.default);

	exports.default = Plot;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _TimeserieChart2 = __webpack_require__(37);

	var _TimeserieChart3 = _interopRequireDefault(_TimeserieChart2);

	var _UtilChart = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var PlotChart = function (_TimeserieChart) {
	    _inherits(PlotChart, _TimeserieChart);

	    function PlotChart() {
	        _classCallCheck(this, PlotChart);

	        return _possibleConstructorReturn(this, (PlotChart.__proto__ || Object.getPrototypeOf(PlotChart)).apply(this, arguments));
	    }

	    _createClass(PlotChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var plots = function () {
	                return _this2.props.data.map(function (d) {
	                    return (0, _UtilChart.getPlot)(_this2.props.plot, _this2.props.xScale(d.x), _this2.props.yScale(d.y), _this2.props.color);
	                });
	            }();

	            return _react2.default.createElement(
	                'g',
	                null,
	                plots
	            );
	        }
	    }]);

	    return PlotChart;
	}(_TimeserieChart3.default);

	exports.default = PlotChart;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Serie = __webpack_require__(43);

	var _Serie2 = _interopRequireDefault(_Serie);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _StackedBarChart = __webpack_require__(60);

	var _StackedBarChart2 = _interopRequireDefault(_StackedBarChart);

	var _Bar2 = __webpack_require__(45);

	var _Bar3 = _interopRequireDefault(_Bar2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var StackedBar = function (_Bar) {
	    _inherits(StackedBar, _Bar);

	    function StackedBar() {
	        _classCallCheck(this, StackedBar);

	        return _possibleConstructorReturn(this, (StackedBar.__proto__ || Object.getPrototypeOf(StackedBar)).apply(this, arguments));
	    }

	    _createClass(StackedBar, [{
	        key: 'initXScale',
	        value: function initXScale(xData, layers) {
	            return _get(StackedBar.prototype.__proto__ || Object.getPrototypeOf(StackedBar.prototype), 'initXScale', this).call(this, xData);
	        }
	    }, {
	        key: 'initYDomain',
	        value: function initYDomain(rangeMin, rangeMax) {
	            this.yDomain = d3.scaleLinear().range([rangeMin, rangeMax]);
	            return this;
	        }
	    }, {
	        key: 'initYScale',
	        value: function initYScale(xData, layers) {
	            var domain = d3.extent(layers[layers.length - 1], function (d) {
	                return d[0] + d[1];
	            });
	            this.yScale = this.yDomain.domain([this.yMin || domain[0], this.yMax || domain[1]]).nice();
	            return this;
	        }
	    }, {
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding, layer, color) {
	            return _react2.default.createElement(_StackedBarChart2.default, { data: layer, xdomain: this.xDomain, yScale: this.yScale, height: height, heightPadding: heightPadding, color: color });
	        }
	    }]);

	    return StackedBar;
	}(_Bar3.default);

	exports.default = StackedBar;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _BarChart2 = __webpack_require__(46);

	var _BarChart3 = _interopRequireDefault(_BarChart2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var StackedBarChart = function (_BarChart) {
	    _inherits(StackedBarChart, _BarChart);

	    function StackedBarChart() {
	        _classCallCheck(this, StackedBarChart);

	        return _possibleConstructorReturn(this, (StackedBarChart.__proto__ || Object.getPrototypeOf(StackedBarChart)).apply(this, arguments));
	    }

	    _createClass(StackedBarChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var bars = this.props.data.map(function (d, i) {
	                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.data.x), y: _this2.props.yScale(d[1]), width: _this2.props.xdomain.bandwidth(),
	                    height: _this2.props.yScale(d[0]) - _this2.props.yScale(d[1]), fill: _this2.props.color });
	            });

	            return _react2.default.createElement(
	                'g',
	                null,
	                bars
	            );
	        }
	    }]);

	    return StackedBarChart;
	}(_BarChart3.default);

	exports.default = StackedBarChart;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Serie = __webpack_require__(43);

	var _Serie2 = _interopRequireDefault(_Serie);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _HorizontalStackedBarChart = __webpack_require__(62);

	var _HorizontalStackedBarChart2 = _interopRequireDefault(_HorizontalStackedBarChart);

	var _HorizontalBar2 = __webpack_require__(49);

	var _HorizontalBar3 = _interopRequireDefault(_HorizontalBar2);

	var _lodash = __webpack_require__(20);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var HorizontalStackedBar = function (_HorizontalBar) {
	    _inherits(HorizontalStackedBar, _HorizontalBar);

	    function HorizontalStackedBar() {
	        _classCallCheck(this, HorizontalStackedBar);

	        return _possibleConstructorReturn(this, (HorizontalStackedBar.__proto__ || Object.getPrototypeOf(HorizontalStackedBar)).apply(this, arguments));
	    }

	    _createClass(HorizontalStackedBar, [{
	        key: 'initXScale',
	        value: function initXScale(xData, layers) {
	            var xdomainMax = d3.extent(layers[layers.length - 1], function (d) {
	                return d[0] + d[1];
	            })[1];
	            var dMax = function () {
	                if (xdomainMax < 0) {
	                    return xdomainMax * 0.9;
	                }
	                return xdomainMax * 1.1;
	            }();
	            this.xScale = this.xDomain.domain([0, dMax]).nice();
	            return this;
	        }
	    }, {
	        key: 'initYScale',
	        value: function initYScale(xData, layers) {
	            this.yScale = this.yDomain.domain((0, _lodash.uniq)(xData));
	            return this;
	        }
	    }, {
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding, layer, color) {
	            return _react2.default.createElement(_HorizontalStackedBarChart2.default, { data: layer, ydomain: this.yDomain, yScale: this.yScale, xScale: this.xScale, height: height, widthPadding: widthPadding, color: color });
	        }
	    }]);

	    return HorizontalStackedBar;
	}(_HorizontalBar3.default);

	exports.default = HorizontalStackedBar;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var HorizontalStackedBarChart = function (_ISerie) {
	    _inherits(HorizontalStackedBarChart, _ISerie);

	    function HorizontalStackedBarChart() {
	        _classCallCheck(this, HorizontalStackedBarChart);

	        return _possibleConstructorReturn(this, (HorizontalStackedBarChart.__proto__ || Object.getPrototypeOf(HorizontalStackedBarChart)).apply(this, arguments));
	    }

	    _createClass(HorizontalStackedBarChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var bars = this.props.data.map(function (d, i) {
	                return _react2.default.createElement('rect', { x: _this2.props.xScale(d[0]), y: _this2.props.yScale(d.data.x), width: _this2.props.xScale(d[1]) - _this2.props.xScale(d[0]),
	                    height: _this2.props.ydomain.bandwidth() - 15, fill: _this2.props.color });
	            });

	            return _react2.default.createElement(
	                'g',
	                null,
	                bars
	            );
	        }
	    }]);

	    return HorizontalStackedBarChart;
	}(_ISerie3.default);

	exports.default = HorizontalStackedBarChart;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Serie = __webpack_require__(43);

	var _Serie2 = _interopRequireDefault(_Serie);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _TimeStackedBarChart = __webpack_require__(64);

	var _TimeStackedBarChart2 = _interopRequireDefault(_TimeStackedBarChart);

	var _Timeserie2 = __webpack_require__(42);

	var _Timeserie3 = _interopRequireDefault(_Timeserie2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var TimeStackedBar = function (_Timeserie) {
	    _inherits(TimeStackedBar, _Timeserie);

	    function TimeStackedBar() {
	        _classCallCheck(this, TimeStackedBar);

	        return _possibleConstructorReturn(this, (TimeStackedBar.__proto__ || Object.getPrototypeOf(TimeStackedBar)).apply(this, arguments));
	    }

	    _createClass(TimeStackedBar, [{
	        key: 'initYScale',
	        value: function initYScale(xData, layers) {
	            var domain = d3.extent(layers[layers.length - 1], function (d) {
	                return d[0] + d[1];
	            });
	            this.yScale = this.yDomain.domain([this.yMin || domain[0], this.yMax || domain[1]]).nice();
	            return this;
	        }
	    }, {
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding, layer, color) {
	            return _react2.default.createElement(_TimeStackedBarChart2.default, { data: layer, xdomain: this.xDomain, yScale: this.yScale, height: height, heightPadding: heightPadding, color: color });
	        }
	    }]);

	    return TimeStackedBar;
	}(_Timeserie3.default);

	exports.default = TimeStackedBar;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _BarChart2 = __webpack_require__(46);

	var _BarChart3 = _interopRequireDefault(_BarChart2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TimeStackedBarChart = function (_BarChart) {
	    _inherits(TimeStackedBarChart, _BarChart);

	    function TimeStackedBarChart() {
	        _classCallCheck(this, TimeStackedBarChart);

	        return _possibleConstructorReturn(this, (TimeStackedBarChart.__proto__ || Object.getPrototypeOf(TimeStackedBarChart)).apply(this, arguments));
	    }

	    _createClass(TimeStackedBarChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var bars = this.props.data.map(function (d, i) {
	                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.data.x), y: _this2.props.yScale(d[1]), width: 2,
	                    height: _this2.props.yScale(d[0]) - _this2.props.yScale(d[1]), fill: _this2.props.color });
	            });

	            return _react2.default.createElement(
	                'g',
	                null,
	                bars
	            );
	        }
	    }]);

	    return TimeStackedBarChart;
	}(_BarChart3.default);

	exports.default = TimeStackedBarChart;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _lodash = __webpack_require__(20);

	var _Serie2 = __webpack_require__(43);

	var _Serie3 = _interopRequireDefault(_Serie2);

	var _BoxPlotChart = __webpack_require__(66);

	var _BoxPlotChart2 = _interopRequireDefault(_BoxPlotChart);

	var _BoxPlotFocus = __webpack_require__(67);

	var _BoxPlotFocus2 = _interopRequireDefault(_BoxPlotFocus);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var BoxPlot = function (_Serie) {
	    _inherits(BoxPlot, _Serie);

	    function BoxPlot() {
	        _classCallCheck(this, BoxPlot);

	        return _possibleConstructorReturn(this, (BoxPlot.__proto__ || Object.getPrototypeOf(BoxPlot)).apply(this, arguments));
	    }

	    _createClass(BoxPlot, [{
	        key: 'initXDomain',
	        value: function initXDomain(min, max) {
	            this.xDomain = d3.scalePoint().rangeRound([min, max]).padding([0.5]);
	            return this;
	        }
	    }, {
	        key: 'initYScale',
	        value: function initYScale(yData) {
	            return _get(BoxPlot.prototype.__proto__ || Object.getPrototypeOf(BoxPlot.prototype), 'initYScale', this).call(this, (0, _lodash.flatten)(yData));
	        }
	    }, {
	        key: 'focus',
	        value: function focus(width, height, widthPadding, heightPadding, xScale, yScale, series) {
	            return 'boxplot';
	        }
	    }, {
	        key: 'render',
	        value: function render(width, height, widthPadding, heightPadding) {
	            return _react2.default.createElement(_BoxPlotChart2.default, { data: this.data, xScale: this.xScale, yScale: this.yScale, widthPadding: widthPadding, heightPadding: heightPadding, height: height });
	        }
	    }]);

	    return BoxPlot;
	}(_Serie3.default);

	exports.default = BoxPlot;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _ISerie2 = __webpack_require__(38);

	var _ISerie3 = _interopRequireDefault(_ISerie2);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _UtilChart = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var BoxPlotChart = function (_ISerie) {
	    _inherits(BoxPlotChart, _ISerie);

	    function BoxPlotChart() {
	        var _ref;

	        var _temp, _this, _ret;

	        _classCallCheck(this, BoxPlotChart);

	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }

	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoxPlotChart.__proto__ || Object.getPrototypeOf(BoxPlotChart)).call.apply(_ref, [this].concat(args))), _this), _this.boxQuartiles = function (d) {
	            d.sort(d3.ascending);
	            return [d3.quantile(d, .25), d3.quantile(d, .5), d3.quantile(d, .75)];
	        }, _this.line = function (x1, x2, y1, y2) {
	            return _react2.default.createElement('line', {
	                x1: x1,
	                x2: x2,
	                y1: _this.props.yScale(y1),
	                y2: _this.props.yScale(y2),
	                stroke: 'black',
	                'stroke-width': '5'
	            });
	        }, _this.verticalLine = function (x, yMin, yMax) {
	            return _react2.default.createElement('line', {
	                x1: x,
	                x2: x,
	                y1: _this.props.yScale(yMin),
	                y2: _this.props.yScale(yMax),
	                stroke: 'black',
	                'stroke-width': '5'
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }

	    _createClass(BoxPlotChart, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var boxes = this.props.data.map(function (data) {
	                var minMax = d3.extent(data.y);
	                var quartiles = _this2.boxQuartiles(data.y);
	                var yQ2 = _this2.props.yScale(quartiles[2]);
	                var x = _this2.props.xScale(data.x);
	                return _react2.default.createElement(
	                    'g',
	                    null,
	                    _react2.default.createElement('rect', {
	                        width: '30',
	                        height: _this2.props.yScale(quartiles[0]) - _this2.props.yScale(quartiles[2]),
	                        x: x - 15,
	                        y: yQ2,
	                        fill: 'steelblue' }),
	                    _this2.line(x - 15, x + 15, quartiles[1], quartiles[1]),
	                    _this2.line(x - 15, x + 15, minMax[0], minMax[0]),
	                    _this2.line(x - 15, x + 15, minMax[1], minMax[1]),
	                    _this2.line(x, x, minMax[0], quartiles[0]),
	                    _this2.line(x, x, quartiles[2], minMax[1])
	                );
	            });

	            return _react2.default.createElement(
	                'g',
	                null,
	                boxes
	            );
	        }
	    }]);

	    return BoxPlotChart;
	}(_ISerie3.default);

	exports.default = BoxPlotChart;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Focus2 = __webpack_require__(44);

	var _Focus3 = _interopRequireDefault(_Focus2);

	var _UtilChart = __webpack_require__(40);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _lodash = __webpack_require__(20);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var d3 = window.d3;

	var BoxPlotFocus = function (_Focus) {
	    _inherits(BoxPlotFocus, _Focus);

	    function BoxPlotFocus() {
	        var _ref;

	        var _temp, _this, _ret;

	        _classCallCheck(this, BoxPlotFocus);

	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }

	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoxPlotFocus.__proto__ || Object.getPrototypeOf(BoxPlotFocus)).call.apply(_ref, [this].concat(args))), _this), _this.getYData = function (yData) {
	            var minMax = d3.extent(yData);
	            var quartiles = [d3.quantile(yData, .25), d3.quantile(yData, .5), d3.quantile(yData, .75)];
	            return [].concat(minMax, quartiles).map(function (data) {
	                return { y: data };
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }

	    _createClass(BoxPlotFocus, [{
	        key: 'getValues',
	        value: function getValues(dataPoint, state) {
	            dataPoint.data.y.sort(d3.ascending);
	            var yData = this.getYData(dataPoint.data.y);
	            var yPoint = (0, _UtilChart.getDataPoint)(dataPoint.point, dataPoint.yScale, yData, 'y');
	            var d = dataPoint.data;
	            var xValue = function () {
	                var date = (0, _moment2.default)(d.x);
	                if (date.isValid()) {
	                    return date.toDate().toLocaleDateString() + ' ' + date.toDate().toLocaleTimeString();
	                }
	                return d.x;
	            }();
	            state.xValue = xValue;
	            state.yValue = yPoint.data.y;
	            state.transform = 'translate(' + dataPoint.xScale(xValue) + ',' + dataPoint.yScale(yPoint.data.y) + ')';
	        }
	    }]);

	    return BoxPlotFocus;
	}(_Focus3.default);

	exports.default = BoxPlotFocus;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _reactDom = __webpack_require__(69);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _lodash = __webpack_require__(20);

	var _Legend = __webpack_require__(70);

	var _Legend2 = _interopRequireDefault(_Legend);

	var _Serie = __webpack_require__(43);

	var _Serie2 = _interopRequireDefault(_Serie);

	var _Pie = __webpack_require__(51);

	var _Pie2 = _interopRequireDefault(_Pie);

	var _Axis = __webpack_require__(41);

	var _Axis2 = _interopRequireDefault(_Axis);

	var _Zoom = __webpack_require__(71);

	var _Zoom2 = _interopRequireDefault(_Zoom);

	var _Overlay = __webpack_require__(72);

	var _Overlay2 = _interopRequireDefault(_Overlay);

	var _UtilChart = __webpack_require__(40);

	var _uuid = __webpack_require__(5);

	var _uuid2 = _interopRequireDefault(_uuid);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var IChart = function (_React$Component) {
	    _inherits(IChart, _React$Component);

	    function IChart(state, props) {
	        _classCallCheck(this, IChart);

	        var _this = _possibleConstructorReturn(this, (IChart.__proto__ || Object.getPrototypeOf(IChart)).call(this, props));

	        _this.getXAxis = function (xScale, height, heightPadding) {
	            if (xScale) {
	                return _react2.default.createElement(_Axis2.default, { orient: d3.axisBottom, scale: xScale, tickSizeInner: -height + heightPadding * 2,
	                    translate: 'translate(' + 0 + ',' + (height - heightPadding) + ')' });
	            }
	            return null;
	        };

	        _this.xData = function () {
	            return (0, _lodash.flatten)(_this.state.series.map(function (serie) {
	                return serie.data.map(function (d) {
	                    return d.x;
	                });
	            }));
	        };

	        _this.renderSeriesWithoutYAxis = function (width, widthPadding, height, heightPadding) {
	            var seriesWithoutYAxis = _this.state.series.filter(function (serie) {
	                return !serie.yAxis;
	            });

	            var xData = _this.xData();
	            var yData = (0, _lodash.flattenDeep)(seriesWithoutYAxis.map(function (serie) {
	                return serie.data.map(function (d) {
	                    return d.y;
	                });
	            }));

	            return seriesWithoutYAxis.map(function (serie) {
	                return {
	                    render: serie.initXDomain(widthPadding, width - widthPadding).initXScale(xData, yData).initYDomain(height - heightPadding, heightPadding).initYScale(yData, xData).render(width, height, widthPadding, heightPadding),
	                    xScale: serie.xScale,
	                    yScale: serie.yScale
	                };
	            });
	        };

	        _this.renderSeriesWithYAxis = function (width, widthPadding, height, heightPadding) {
	            var seriesWithYAxis = _this.state.series.filter(function (serie) {
	                return serie.yAxis;
	            });

	            var xData = _this.xData();

	            return seriesWithYAxis.map(function (serie) {
	                var yData = serie.data.map(function (d) {
	                    return d.y;
	                });
	                serie.initXDomain(widthPadding, width - widthPadding).initXScale(xData, yData).initYDomain(height - heightPadding, heightPadding).initYScale(yData, xData);
	                var yAxis = (0, _UtilChart.getYAxis)(serie.yScale, width, widthPadding, serie.yAxis);
	                var render = _react2.default.createElement(
	                    'g',
	                    null,
	                    serie.render(width, height, widthPadding, heightPadding),
	                    yAxis
	                );
	                return {
	                    render: render,
	                    xScale: serie.xScale,
	                    yScale: serie.yScale
	                };
	            });
	        };

	        _this.clickSerie = function (serie) {
	            var clicked = _this.props.series.find(function (s) {
	                return s.name == serie;
	            });
	            var foundSerie = (0, _lodash.findIndex)(_this.state.series, { name: serie });
	            var series = _this.state.series.slice();

	            if (foundSerie !== -1) {
	                series.splice(foundSerie, 1);
	            } else {
	                series.push(clicked);
	            }
	            _this.setState({ series: series });
	        };

	        _this.reset = function () {
	            _this.setState({ series: _this.props.series });
	        };

	        _this.updateData = function (screenClient) {
	            var newSeries = _this.state.series.map(function (serie) {
	                var first = _this.findDataPoint(serie.data, (0, _UtilChart.getDataPoint)({
	                    x: screenClient.xStart,
	                    y: screenClient.yStart
	                }, screenClient.scale, serie.data));
	                var last = _this.findDataPoint(serie.data, (0, _UtilChart.getDataPoint)({
	                    x: screenClient.xEnd,
	                    y: screenClient.yEnd
	                }, screenClient.scale, serie.data));
	                var cloneSerie = (0, _lodash.clone)(serie);
	                cloneSerie.data = serie.data.slice(first, last);
	                return cloneSerie;
	            });
	            _this.setState({ series: newSeries });
	        };

	        _this.findDataPoint = function (data, dataPoint) {
	            if (dataPoint.data) {
	                return (0, _lodash.findIndex)(data, function (d) {
	                    return d.x === dataPoint.data.x;
	                });
	            }
	            return data.length - 1;
	        };

	        _this.zoom = function () {
	            if (_this.props.zoomable) {
	                return {
	                    reset: _this.reset,
	                    updateData: _this.updateData
	                };
	            }
	            return null;
	        };

	        _this.state = Object.assign({}, {
	            series: [],
	            width: 300,
	            chartId: _uuid2.default.v4()
	        }, state);
	        return _this;
	    }

	    _createClass(IChart, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ series: this.props.series });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setState({ width: _reactDom2.default.findDOMNode(this).getBoundingClientRect().width });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ series: nextProps.series });
	        }
	    }, {
	        key: 'getYAxis',
	        value: function getYAxis(yScale, width, widthPadding) {
	            if (yScale) {
	                return (0, _UtilChart.getYAxis)(yScale, width, widthPadding);
	            }
	            return null;
	        }
	    }, {
	        key: 'legend',
	        value: function legend(width, widthPadding, height, heightPadding) {
	            if (this.props.legend) {
	                if (this.props.series[0] instanceof _Pie2.default) {
	                    return _react2.default.createElement(_Legend2.default, { series: this.props.series[0].data, widthPadding: widthPadding,
	                        heightPadding: this.props.height * 0.97, clickSerie: this.clickSerie });
	                }
	                return _react2.default.createElement(_Legend2.default, { series: this.props.series, widthPadding: widthPadding,
	                    heightPadding: this.props.height * 0.98, clickSerie: this.clickSerie });
	            }
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var widthPadding = this.state.width * this.props.widthPadding;
	            var heightPadding = this.props.height * 0.05;

	            var width = this.state.width;
	            var height = this.props.height - heightPadding;

	            var render = this.renderSeriesWithoutYAxis(width, widthPadding, height, heightPadding);
	            var seriesWithYAxis = this.renderSeriesWithYAxis(width, widthPadding, height, heightPadding);

	            var scale = function () {
	                if (render.length > 0) {
	                    return {
	                        xScale: render[0].xScale,
	                        yScale: render[0].yScale
	                    };
	                }
	                return {
	                    xScale: seriesWithYAxis[0].xScale,
	                    yScale: seriesWithYAxis[0].yScale
	                };
	            }();

	            var focus = function () {
	                if (_this2.props.series[0].focus) {
	                    return _this2.props.series[0].focus();
	                }
	                return undefined;
	            }();

	            var legend = this.legend(width, widthPadding, height, heightPadding);

	            return _react2.default.createElement(
	                'svg',
	                { width: '100%', height: '100%', viewBox: '0 0 ' + this.state.width + ' ' + this.props.height,
	                    xmlns: 'http://www.w3.org/2000/svg', version: '1.1', id: this.state.chartId },
	                render.map(function (serie) {
	                    return serie.render;
	                }),
	                seriesWithYAxis.map(function (serie) {
	                    return serie.render;
	                }),
	                this.getXAxis(scale.xScale, height, heightPadding),
	                this.getYAxis(scale.yScale, width, widthPadding),
	                _react2.default.createElement(_Overlay2.default, {
	                    zoom: this.zoom(),
	                    focus: focus,
	                    width: width,
	                    height: height,
	                    widthPadding: widthPadding,
	                    heightPadding: heightPadding,
	                    chartId: this.state.chartId,
	                    series: this.state.series }),
	                legend
	            );
	        }
	    }]);

	    return IChart;
	}(_react2.default.Component);

	IChart.propTypes = {
	    series: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.instanceOf(_Serie2.default)),
	    legend: _react2.default.PropTypes.bool,
	    height: _react2.default.PropTypes.number,
	    width: _react2.default.PropTypes.number,
	    widthPadding: _react2.default.PropTypes.number
	};

	IChart.defaultProps = {
	    widthPadding: 0.05
	};

	exports.default = IChart;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = require("react-dom");

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Serie = __webpack_require__(43);

	var _Serie2 = _interopRequireDefault(_Serie);

	var _UtilChart = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Legend = function (_Component) {
		_inherits(Legend, _Component);

		function Legend(props) {
			_classCallCheck(this, Legend);

			var _this = _possibleConstructorReturn(this, (Legend.__proto__ || Object.getPrototypeOf(Legend)).call(this, props));

			_this.calculatePadding = function () {
				var size = _this.refs.legend.children.length;
				var padding = [];
				for (var i = 0; i < size; ++i) {
					if (i > 0) {
						padding.push(padding[i - 1] + _this.refs.legend.children[i].getBBox().width + 20);
					} else {
						padding.push(_this.refs.legend.children[i].getBBox().width);
					}
				}
				_this.setState({ padding: padding });
			};

			_this.state = { padding: [] };
			return _this;
		}

		_createClass(Legend, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.calculatePadding();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				if (prevProps.series.length !== this.props.series.length) {
					this.calculatePadding();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;

				var legend = this.props.series.map(function (serie, i) {
					var widthPadding = function () {
						if (_this2.state.padding.length > 0 && i !== 0) {
							return _this2.props.widthPadding + _this2.state.padding[i - 1] + 20;
						}
						return _this2.props.widthPadding;
					}();
					var plot = (0, _UtilChart.getPlot)(serie.plot, 0, 0, serie.color);
					return _react2.default.createElement(
						'g',
						{ transform: 'translate(' + widthPadding + ',' + _this2.props.heightPadding + ')', className: 'clickable', onClick: function onClick() {
								return _this2.props.clickSerie(serie.name);
							} },
						plot,
						_react2.default.createElement(
							'text',
							{ transform: 'translate(10,5)' },
							serie.name
						)
					);
				});

				return _react2.default.createElement(
					'g',
					{ ref: 'legend' },
					legend
				);
			}
		}]);

		return Legend;
	}(_react.Component);

	Legend.propTypes = {
		series: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.instanceOf(_Serie2.default)),
		widthPadding: _react2.default.PropTypes.number,
		heightPadding: _react2.default.PropTypes.number
	};

	exports.default = Legend;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _UtilChart = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Zoom = function (_React$Component) {
		_inherits(Zoom, _React$Component);

		function Zoom() {
			_classCallCheck(this, Zoom);

			var _this = _possibleConstructorReturn(this, (Zoom.__proto__ || Object.getPrototypeOf(Zoom)).call(this));

			_this.state = {
				drag: false,
				dragX: 0,
				dragY: 0,
				dragXStart: 0,
				dragYStart: 0,
				resetVisibility: 'hidden'
			};
			return _this;
		}

		_createClass(Zoom, [{
			key: 'mouseMove',
			value: function mouseMove(e) {
				e.preventDefault();
				var mousePoint = (0, _UtilChart.getMouse)(e, this.props.chartId);
				var state = {};
				if (this.state.drag) {
					state.dragX = mousePoint.x;
					state.dragY = mousePoint.y;
				}
				this.setState(state);
			}
		}, {
			key: 'mouseDown',
			value: function mouseDown(e) {
				e.preventDefault();
				var mousePoint = (0, _UtilChart.getMouse)(e, this.props.chartId);
				this.setState({
					drag: true,
					dragXStart: mousePoint.x,
					dragYStart: mousePoint.y,
					dragX: mousePoint.x,
					dragY: mousePoint.y
				});
			}
		}, {
			key: 'mouseUp',
			value: function mouseUp(e) {
				e.preventDefault();
				this.setState({ drag: false, dragXStart: 0, dragYStart: 0, dragX: 0, dragY: 0, resetVisibility: 'visible' });

				var mouse = (0, _UtilChart.getMouse)(e, this.props.chartId);

				this.props.updateData({
					xStart: this.state.dragXStart,
					yStart: this.state.dragYStart,
					xEnd: mouse.x,
					yEnd: mouse.y,
					scale: this.props.xScale
				});
			}
		}, {
			key: 'reset',
			value: function reset() {
				this.setState({ resetVisibility: 'hidden' });
				this.props.reset();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;

				var drag = _react2.default.createElement('rect', { className: 'drag', width: Math.abs(this.state.dragXStart - this.state.dragX),
					height: Math.abs(this.state.dragYStart - this.state.dragY), x: this.state.dragXStart,
					y: this.state.dragYStart });

				var translate = this.props.width - 10;

				var reset = _react2.default.createElement(
					'g',
					{ className: 'reset', title: 'Zoom d\'origine', transform: 'translate(' + translate + ',20)',
						visibility: this.state.resetVisibility, onClick: function onClick() {
							return _this2.reset();
						} },
					_react2.default.createElement(
						'title',
						null,
						'Zoom d\'origine'
					),
					_react2.default.createElement('rect', { rx: '3', ry: '3', fill: 'url(#highcharts-10)', x: '-2.5', y: '0.5', width: '105', height: '18', strokeWidth: '1',
						stroke: '#999' }),
					_react2.default.createElement(
						'text',
						{ x: '0', y: '16' },
						_react2.default.createElement(
							'tspan',
							{ x: '0' },
							'Zoom d\'origine'
						)
					)
				);

				return _react2.default.createElement(
					'g',
					null,
					drag,
					reset
				);
			}
		}]);

		return Zoom;
	}(_react2.default.Component);

	Zoom.propTypes = {
		updateData: _react2.default.PropTypes.func,
		reset: _react2.default.PropTypes.func,
		width: _react2.default.PropTypes.number
	};

	exports.default = Zoom;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Focus = __webpack_require__(44);

	var _Focus2 = _interopRequireDefault(_Focus);

	var _BoxPlotFocus = __webpack_require__(67);

	var _BoxPlotFocus2 = _interopRequireDefault(_BoxPlotFocus);

	var _AreaRangeFocus = __webpack_require__(73);

	var _AreaRangeFocus2 = _interopRequireDefault(_AreaRangeFocus);

	var _Zoom = __webpack_require__(71);

	var _Zoom2 = _interopRequireDefault(_Zoom);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Overlay = function (_Component) {
	    _inherits(Overlay, _Component);

	    function Overlay() {
	        var _ref;

	        var _temp, _this, _ret;

	        _classCallCheck(this, Overlay);

	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }

	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
	            switch (_this.props.focus) {
	                case 'focus':
	                    return _react2.default.createElement(_Focus2.default, {
	                        ref: 'focus',
	                        width: _this.props.width,
	                        height: _this.props.height,
	                        widthPadding: _this.props.widthPadding,
	                        heightPadding: _this.props.heightPadding,
	                        series: _this.props.series,
	                        chartId: _this.props.chartId });
	                case 'boxplot':
	                    return _react2.default.createElement(_BoxPlotFocus2.default, {
	                        ref: 'focus',
	                        width: _this.props.width,
	                        height: _this.props.height,
	                        widthPadding: _this.props.widthPadding,
	                        heightPadding: _this.props.heightPadding,
	                        series: _this.props.series,
	                        chartId: _this.props.chartId });
	                case 'arearange':
	                    return _react2.default.createElement(_AreaRangeFocus2.default, {
	                        ref: 'focus',
	                        width: _this.props.width,
	                        height: _this.props.height,
	                        widthPadding: _this.props.widthPadding,
	                        heightPadding: _this.props.heightPadding,
	                        series: _this.props.series,
	                        chartId: _this.props.chartId });
	                default:
	                    return null;
	            }
	        }, _this.zoom = function () {
	            if (_this.props.zoom) {
	                return _react2.default.createElement(_Zoom2.default, {
	                    xScale: _this.props.series[0].xScale,
	                    width: _this.props.width,
	                    height: _this.props.height,
	                    widthPadding: _this.props.widthPadding,
	                    heightPadding: _this.props.heightPadding,
	                    reset: _this.props.zoom.reset,
	                    updateData: _this.props.zoom.updateData,
	                    ref: 'zoom',
	                    chartId: _this.props.chartId });
	            }
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }

	    _createClass(Overlay, [{
	        key: 'mouseOver',
	        value: function mouseOver(e) {
	            e.preventDefault();
	            if (this.refs.focus) {
	                this.refs.focus.mouseOver(e);
	            }
	        }
	    }, {
	        key: 'mouseOut',
	        value: function mouseOut(e) {
	            e.preventDefault();
	            if (this.refs.focus) {
	                this.refs.focus.mouseOut(e);
	            }
	        }
	    }, {
	        key: 'mouseMove',
	        value: function mouseMove(e) {
	            e.preventDefault();
	            if (this.refs.focus) {
	                this.refs.focus.mouseMove(e);
	            }
	            if (this.refs.zoom) {
	                this.refs.zoom.mouseMove(e);
	            }
	        }
	    }, {
	        key: 'mouseDown',
	        value: function mouseDown(e) {
	            e.preventDefault();
	            if (this.refs.zoom) {
	                this.refs.zoom.mouseDown(e);
	            }
	        }
	    }, {
	        key: 'mouseUp',
	        value: function mouseUp(e) {
	            e.preventDefault();
	            if (this.refs.zoom) {
	                this.refs.zoom.mouseUp(e);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            return _react2.default.createElement(
	                'g',
	                null,
	                _react2.default.createElement('rect', { className: 'overlay', width: this.props.width, height: this.props.height, x: this.props.widthPadding, y: this.props.heightPadding,
	                    onMouseOver: function onMouseOver(e) {
	                        return _this2.mouseOver(e);
	                    },
	                    onMouseOut: function onMouseOut(e) {
	                        return _this2.mouseOut(e);
	                    },
	                    onMouseMove: function onMouseMove(e) {
	                        return _this2.mouseMove(e);
	                    },
	                    onMouseDown: function onMouseDown(e) {
	                        return _this2.mouseDown(e);
	                    },
	                    onMouseUp: function onMouseUp(e) {
	                        return _this2.mouseUp(e);
	                    } }),
	                this.focus(),
	                this.zoom()
	            );
	        }
	    }]);

	    return Overlay;
	}(_react.Component);

	exports.default = Overlay;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Focus2 = __webpack_require__(44);

	var _Focus3 = _interopRequireDefault(_Focus2);

	var _UtilChart = __webpack_require__(40);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _lodash = __webpack_require__(20);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var AreaRangeFocus = function (_Focus) {
	    _inherits(AreaRangeFocus, _Focus);

	    function AreaRangeFocus() {
	        var _ref;

	        var _temp, _this, _ret;

	        _classCallCheck(this, AreaRangeFocus);

	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }

	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AreaRangeFocus.__proto__ || Object.getPrototypeOf(AreaRangeFocus)).call.apply(_ref, [this].concat(args))), _this), _this.getDataPoint = function (points, mouse) {
	            var newPoints = (0, _lodash.flatten)(points.map(function (point) {
	                if (point.data.y.length > 1) {
	                    return point.data.y.map(function (y) {
	                        var clonePoint = (0, _lodash.cloneDeep)(point);
	                        clonePoint.data.y = y;
	                        return clonePoint;
	                    });
	                }
	                return point;
	            }));

	            if (newPoints.length > 1) {
	                return (0, _lodash.minBy)(newPoints.map(function (point) {
	                    var serie = _this.findSerie(point.data);
	                    var invert = (0, _UtilChart.getInvert)(serie.yScale, mouse, 'y');
	                    return {
	                        data: point.data,
	                        abs: Math.abs(point.data.y - invert)
	                    };
	                }), 'abs');
	            }
	            return newPoints[0];
	        }, _this.findSerie = function (d) {
	            return _this.props.series.find(function (s) {
	                return s.data.find(function (data) {
	                    if (data.y.length > 1) {
	                        return data.x == d.x && data.y.indexOf(d.y) != -1;
	                    }
	                    return data.x == d.x && data.y == d.y;
	                }) !== undefined;
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }

	    return AreaRangeFocus;
	}(_Focus3.default);

	exports.default = AreaRangeFocus;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _uuid = __webpack_require__(5);

	var _uuid2 = _interopRequireDefault(_uuid);

	var _moment = __webpack_require__(39);

	var _moment2 = _interopRequireDefault(_moment);

	var _simpleReactI18n = __webpack_require__(29);

	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);

	var _datepicker_fr = __webpack_require__(75);

	var _datepicker_fr2 = _interopRequireDefault(_datepicker_fr);

	var _datepicker = __webpack_require__(76);

	var _datepicker2 = _interopRequireDefault(_datepicker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	_simpleReactI18n2.default.addLang(_datepicker_fr2.default, ['fr', 'FR']);
	_simpleReactI18n2.default.addLang(_datepicker2.default, 'default');
	_simpleReactI18n2.default.init();

	var Materialize = window.Materialize;

	var DatePicker = function (_Component) {
	    _inherits(DatePicker, _Component);

	    function DatePicker(props) {
	        _classCallCheck(this, DatePicker);

	        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

	        _this.onChange = function () {
	            var value = _this.refs[_this.state.datepickerId].value;
	            _this.props.onChange({
	                text: value,
	                timestamp: (0, _moment2.default)(value, _this.props.format.toUpperCase()).valueOf()
	            });
	            _this.setState({ value: value });
	        };

	        _this.state = {
	            datepickerId: _uuid2.default.v4(),
	            value: ''
	        };
	        return _this;
	    }

	    _createClass(DatePicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ value: this.props.value });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ value: nextProps.value });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            $('.datepicker').pickadate({
	                labelMonthNext: 'Mois suivant',
	                labelMonthPrev: 'Mois précédent',
	                labelMonthSelect: 'Selectionner le mois',
	                labelYearSelect: 'Selectionner une année',
	                monthsFull: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
	                monthsShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
	                weekdaysFull: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
	                weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	                weekdaysLetter: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	                selectMonths: true,
	                selectYears: 15,
	                today: _simpleReactI18n2.default.today,
	                clear: _simpleReactI18n2.default.clean,
	                close: _simpleReactI18n2.default.close,
	                closeOnSelect: false,
	                format: this.props.format,
	                firstDay: '1',
	                onClose: this.onChange
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var className = function () {
	                if (_this2.props.value) {
	                    return 'active';
	                }
	                return '';
	            }();
	            return _react2.default.createElement(
	                'div',
	                { className: 'input-field' },
	                _react2.default.createElement('input', { type: 'text', className: 'datepicker', id: this.state.datepickerId, ref: this.state.datepickerId, value: this.state.value }),
	                _react2.default.createElement(
	                    'label',
	                    { className: className, htmlFor: this.state.datepickerId },
	                    this.props.title
	                )
	            );
	        }
	    }]);

	    return DatePicker;
	}(_react.Component);

	DatePicker.propTypes = {
	    format: _react2.default.PropTypes.string,
	    title: _react2.default.PropTypes.string,
	    value: _react2.default.PropTypes.string,
	    onChange: _react2.default.PropTypes.func.isRequired
	};

	DatePicker.defaultProps = {
	    format: 'dd/mm/yyyy'
	};

	exports.default = DatePicker;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = {"today":"Aujourd'hui","clean":"Effacer","close":"Valider"}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = {"today":"Aujourd'hui","clean":"Effacer","close":"Valider"}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _uuid = __webpack_require__(5);

	var _uuid2 = _interopRequireDefault(_uuid);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var $ = window.$;
	var Materialize = window.Materialize;

	var AutoComplete = function (_Component) {
	    _inherits(AutoComplete, _Component);

	    function AutoComplete(props) {
	        _classCallCheck(this, AutoComplete);

	        var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this, props));

	        _this.initialiseWidgets = function () {
	            var newValues = _this.props.values.reduce(function (acc, value) {
	                acc[value.label] = value.href ? value.href : null;
	                return acc;
	            }, {});

	            if ($('#' + _this.state.autocompleteId).autocomplete) {
	                $('#' + _this.state.autocompleteId).autocomplete({
	                    data: newValues,
	                    limit: _this.props.limit, // The max amount of results that can be shown at once. Default: Infinity.
	                    minLength: _this.props.minLength, // The minimum length of the input for the autocomplete to start. Default: 1.
	                    onAutocomplete: function onAutocomplete(val) {
	                        _this.props.onChange(_this.props.values.find(function (v) {
	                            return v.label == val;
	                        }));
	                    }
	                });
	            }

	            if (Materialize.updateTextFields) {
	                Materialize.updateTextFields();
	            }
	        };

	        _this.changeValue = function (e) {
	            _this.setState({ value: e.target.value });
	        };

	        _this.state = {
	            autocompleteId: _uuid2.default.v4(),
	            value: ''
	        };
	        return _this;
	    }

	    _createClass(AutoComplete, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ value: this.props.selected });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.initialiseWidgets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ value: nextProps.selected });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.initialiseWidgets();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var defaultValue = this.props.values.find(function (v) {
	                return v.value === _this2.state.value;
	            });
	            return _react2.default.createElement(
	                'div',
	                { className: 'input-field' },
	                _react2.default.createElement('input', { type: 'text', id: this.state.autocompleteId, className: 'autocomplete', value: defaultValue ? defaultValue.label : this.state.value, onChange: this.changeValue }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.state.autocompleteId },
	                    this.props.title
	                )
	            );
	        }
	    }]);

	    return AutoComplete;
	}(_react.Component);

	AutoComplete.propTypes = {
	    values: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	    title: _react2.default.PropTypes.string,
	    onChange: _react2.default.PropTypes.function,
	    limit: _react2.default.PropTypes.number,
	    minLength: _react2.default.PropTypes.number,
	    selected: _react2.default.PropTypes.string
	};

	AutoComplete.defaultProps = {
	    values: [{
	        label: '',
	        href: null
	    }],
	    title: 'Autocomplete',
	    onChange: '',
	    limit: 10,
	    minLength: 1,
	    selected: ''
	};

	exports.default = AutoComplete;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _Input2 = __webpack_require__(4);

	var _Input3 = _interopRequireDefault(_Input2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Texarea = function (_Input) {
	    _inherits(Texarea, _Input);

	    function Texarea() {
	        _classCallCheck(this, Texarea);

	        return _possibleConstructorReturn(this, (Texarea.__proto__ || Object.getPrototypeOf(Texarea)).apply(this, arguments));
	    }

	    _createClass(Texarea, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;

	            var className = 'input-field ' + (this.props.className || '');

	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement('textarea', { className: 'materialize-textarea', ref: function ref(_ref) {
	                        return _this2.inputRef = _ref;
	                    },
	                    id: this.state.selectId, value: this.state.value, onChange: this.changeValue }),
	                this.getLabel()
	            );
	        }
	    }]);

	    return Texarea;
	}(_Input3.default);

	exports.default = Texarea;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _openlayers = __webpack_require__(80);

	var _openlayers2 = _interopRequireDefault(_openlayers);

	var _reactDom = __webpack_require__(69);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _Popup = __webpack_require__(81);

	var _Popup2 = _interopRequireDefault(_Popup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Map = function (_Component) {
	    _inherits(Map, _Component);

	    function Map(props) {
	        _classCallCheck(this, Map);

	        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

	        _this.createMeasureTooltip = function () {
	            if (_this.measureTooltipElement) {
	                _this.measureTooltipElement.parentNode.removeChild(_this.measureTooltipElement);
	            }
	            _this.measureTooltipElement = document.createElement('div');
	            _this.measureTooltipElement.className = 'tooltip tooltip-measure';
	            _this.measureTooltip = new _openlayers2.default.Overlay({
	                element: _this.measureTooltipElement,
	                offset: [0, -15],
	                positioning: 'bottom-center'
	            });
	            _this.olMap.addOverlay(_this.measureTooltip);
	        };

	        _this.clickMap = function (e) {
	            e.preventDefault();
	            if (!_this.props.drawFunction) {
	                _this.setState({ event: { clientX: e.clientX, clientY: e.clientY } });
	                if (_this.props.event) {
	                    var coordinate = _this.olMap.getCoordinateFromPixel(_this.olMap.getEventPixel({
	                        clientX: e.clientX,
	                        clientY: e.clientY
	                    }));
	                    var pointTransform = _openlayers2.default.proj.transform(coordinate, 'EPSG:3857', 'EPSG:4326');
	                    _this.props.event(pointTransform, _this.state.zoom);
	                }
	            }
	        };

	        _this.state = {
	            event: {},
	            popup: []
	        };
	        return _this;
	    }

	    _createClass(Map, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;

	            var layersTab = this.props.layers.map(function (el) {
	                return el.getLayer();
	            });
	            if (this.props.drawFunction) {
	                var source = new _openlayers2.default.source.Vector({ wrapX: false });

	                var vector = new _openlayers2.default.layer.Vector({
	                    source: source
	                });
	                layersTab = [].concat(layersTab, vector);
	                this.source = source;
	            }
	            var map = new _openlayers2.default.Map({
	                layers: layersTab,
	                view: new _openlayers2.default.View({
	                    center: _openlayers2.default.proj.fromLonLat(this.props.mapConf.center),
	                    zoom: this.props.mapConf.zoom
	                })
	            });
	            var ghostZoom = map.getView().getZoom();
	            map.on('moveend', function () {
	                if (ghostZoom != map.getView().getZoom()) {
	                    _this2.setState({ zoom: map.getView().getZoom() });
	                }
	            });

	            this.olMap = map;
	            if (this.props.drawFunction) {
	                var draw = new _openlayers2.default.interaction.Draw({
	                    source: this.source,
	                    type: 'Circle'
	                });
	                map.addInteraction(draw);
	                this.listener = '';
	                this.coord = '';
	                this.radius = '';
	                this.measureTooltipElement = '';
	                this.measureTooltip = '';
	                this.createMeasureTooltip();
	                draw.on('drawstart', function (evt) {
	                    evt.feature.getGeometry().on('change', function (event) {
	                        var units = map.getView().getProjection().getUnits();
	                        _this2.listener = event.target;
	                        _this2.measureTooltipElement.innerHTML = (_this2.listener.getRadius() * _openlayers2.default.proj.METERS_PER_UNIT[units] / 1000).toFixed(2);
	                        _this2.measureTooltip.setPosition(_this2.listener.getLastCoordinate());
	                    });
	                }, this);
	                draw.on('drawend', function (evt) {
	                    this.coord = _openlayers2.default.proj.transform(evt.feature.getGeometry().getFirstCoordinate(), 'EPSG:3857', 'EPSG:4326');
	                    this.radius = this.listener.getRadius() / 1000;
	                    this.props.radius(this.coord, this.radius);
	                }, this);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var map = _reactDom2.default.findDOMNode(this.refs.map);
	            this.olMap.setTarget(map);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this3 = this;

	            var added = nextProps.layers.filter(function (next) {
	                return !_this3.props.layers.find(function (prec) {
	                    return prec === next;
	                });
	            });

	            added.forEach(function (element) {
	                _this3.olMap.addLayer(element.getLayer());
	            }, this);

	            var removed = this.props.layers.filter(function (prec) {
	                return !nextProps.layers.find(function (next) {
	                    return prec === next;
	                });
	            });

	            removed.forEach(function (element) {
	                _this3.olMap.removeLayer(element.getLayer());
	            }, this);
	            this.olMap.getView().setCenter(_openlayers2.default.proj.fromLonLat(nextProps.mapConf.center));
	            this.olMap.getView().setZoom(nextProps.mapConf.zoom);
	            this.olMap.updateSize();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { id: 'map', style: { height: this.props.mapConf.size + 'px' }, ref: 'map', onClick: this.clickMap },
	                _react2.default.createElement(_Popup2.default, { olMap: this.olMap, layers: this.props.layers, event: this.state.event,
	                    popupProps: this.props.popupProps })
	            );
	        }
	    }]);

	    return Map;
	}(_react.Component);

	Map.propTypes = {
	    layers: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	    popupProps: _react2.default.PropTypes.shape({ filters: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string) }),
	    mapConf: _react2.default.PropTypes.shape({
	        size: _react2.default.PropTypes.number,
	        center: _react2.default.PropTypes.array,
	        zoom: _react2.default.PropTypes.number
	    }),
	    event: _react2.default.PropTypes.func,
	    drawFunction: _react2.default.PropTypes.bool,
	    radius: _react2.default.PropTypes.func
	};

	Map.defaultProps = {
	    mapConf: {
	        size: 300,
	        center: [47.123010186224576, -1.820669934399723],
	        zoom: 10
	    },
	    layers: [],
	    popupProps: { filters: [] },
	    drawFunction: false,
	    event: function event() {},
	    radius: function radius() {},
	    zoom: 10
	};

	exports.default = Map;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = require("openlayers");

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _openlayers = __webpack_require__(80);

	var _openlayers2 = _interopRequireDefault(_openlayers);

	var _reactDom = __webpack_require__(69);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _PopupContent = __webpack_require__(82);

	var _PopupContent2 = _interopRequireDefault(_PopupContent);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _react2.default.createClass({
	    displayName: 'Popup',


	    propTypes: {
	        olMap: _react2.default.PropTypes.instanceOf(_openlayers2.default.Map),
	        event: _react2.default.PropTypes.shape({ clientX: _react2.default.PropTypes.number, clientY: _react2.default.PropTypes.number }),
	        layers: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        popupProps: _react2.default.PropTypes.shape({ filters: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string) })
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            olMap: {},
	            event: {},
	            layers: [],
	            popupProps: { filters: [] }
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            feature: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var container = _reactDom2.default.findDOMNode(this.refs.popup);
	        this.popup = new _openlayers2.default.Overlay({
	            positioning: 'bottom-center',
	            autoPan: true,
	            autoPanAnimation: {
	                duration: 250
	            },
	            offset: [0, 0]
	        });
	        this.props.olMap.addOverlay(this.popup);
	        this.popup.setElement(container);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this = this;

	        var arr = [];
	        var popup = this.popup;
	        nextProps.olMap.forEachFeatureAtPixel(this.props.olMap.getEventPixel(nextProps.event), function (feature) {
	            var havePopup = _this.props.layers.find(function (la) {
	                return la.checkUuid(feature.getId());
	            }).getPopup();
	            var isOnFilter = _this.props.popupProps.filters.includes(feature.getGeometry().getType());
	            if (havePopup && isOnFilter) {
	                arr.push(feature);
	            }
	        });
	        if (arr.length > 0) {
	            this.setState({ feature: arr });
	            popup.setPosition(this.props.olMap.getCoordinateFromPixel(this.props.olMap.getEventPixel(nextProps.event)));
	        } else {
	            popup.setPosition(undefined);
	        }
	    },
	    getContent: function getContent() {
	        var _this2 = this;

	        if (this.state.feature.length > 0) {
	            var filterLayers = this.state.feature.map(function (ft) {
	                return _this2.props.layers.find(function (la) {
	                    return la.checkUuid(ft.getId());
	                });
	            });
	            return _react2.default.createElement(_PopupContent2.default, { features: this.state.feature, layers: filterLayers });
	        }
	        return [];
	    },


	    render: function render() {
	        var popupContent = this.getContent();
	        return _react2.default.createElement(
	            'div',
	            { ref: 'popup', className: 'ol-popup' },
	            popupContent
	        );
	    }
	});

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _react2.default.createClass({
	    displayName: 'PopupContent',


	    propTypes: {
	        layers: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        features: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object)
	    },

	    getInitialState: function getInitialState() {
	        return {
	            selected: ''
	        };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            layers: [],
	            features: []
	        };
	    },
	    getFeatureProxy: function getFeatureProxy(feature) {
	        var handler = {
	            get: function get(target, name) {
	                // You must use .get to access to props of feature.
	                if (name === 'id') {
	                    return target.getId();
	                }
	                return target.get(name);
	            }
	        };
	        return new Proxy(feature, handler);
	    },
	    componentWillMount: function componentWillMount() {
	        var _this = this;

	        var feature = this.getFeatureProxy(this.props.features[0]);
	        var lay = this.props.layers.find(function (la) {
	            return la.checkUuid(_this.props.features[0].getId());
	        });
	        this.setState({ selected: lay.getPopup().content(lay, feature) });
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;

	        if (nextProps.features) {
	            if (this.props.features.length > 1) {
	                this.props.features.forEach(function (element) {
	                    _this2['couche' + element.getId()].removeEventListener('click', _this2.handlerListener(element));
	                });
	            }

	            var lay = nextProps.layers.find(function (la) {
	                return la.checkUuid(nextProps.features[0].getId());
	            });
	            var feature = this.getFeatureProxy(nextProps.features[0]);
	            this.setState({ selected: lay.getPopup().content(lay, feature) });
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        this.createListener();
	    },
	    componentDidUpdate: function componentDidUpdate(prevProps) {
	        // no props check create too much listener
	        if (prevProps.features !== this.props.features) {
	            this.createListener();
	        }
	    },
	    createListener: function createListener() {
	        var _this3 = this;

	        if (this.props.features.length > 1) {
	            this.props.features.forEach(function (element) {
	                // React can't trigger click on the map. You must use EventListener, after the DOM render.
	                _this3['couche' + element.getId()].removeEventListener('click', _this3.handlerListener(element));
	                _this3['couche' + element.getId()].addEventListener('click', _this3.handlerListener(element));
	            });
	        }
	    },
	    handlerListener: function handlerListener(element) {
	        var _this4 = this;

	        return function () {
	            var feature = _this4.getFeatureProxy(element);
	            var lay = _this4.props.layers.find(function (la) {
	                return la.checkUuid(element.getId());
	            });
	            return _this4.setState({ selected: lay.getPopup().content(lay, feature) });
	        };
	    },
	    getContent: function getContent() {
	        var _this5 = this;

	        // creation of childs components is too hard because you must use eventlistener over 2 components..
	        var list = this.props.features.map(function (element) {
	            var lay = _this5.props.layers.find(function (la) {
	                return la.checkUuid(element.getId());
	            });
	            return _react2.default.createElement(
	                'li',
	                { key: element.getId() },
	                _react2.default.createElement(
	                    'a',
	                    { className: 'truncate', ref: function ref(el) {
	                            _this5['couche' + element.getId()] = el;
	                        } },
	                    lay.type.title
	                )
	            );
	        });
	        if (list.length > 1) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'row no-margin' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col s4 border-right' },
	                    _react2.default.createElement(
	                        'ul',
	                        { id: 'menu' },
	                        list
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col s8' },
	                    this.state.selected
	                )
	            );
	        }
	        return _react2.default.createElement(
	            'div',
	            { className: 'row no-margin' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col s12' },
	                this.state.selected
	            )
	        );
	    },


	    render: function render() {
	        var content = this.getContent();
	        return _react2.default.createElement(
	            'div',
	            { id: 'popover-content' },
	            content
	        );
	    }
	});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
		popupStationPoint: {
			name: function name(layer) {
				return layer.type.name;
			},
			content: function content(layer, feature) {
				var station = layer.getUuid().find(function (el) {
					return el.uuid === feature.id;
				}).obj;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						station.code,
						' '
					),
					':',
					_react2.default.createElement('br', null),
					feature.name
				);
			}
		},
		popupSitePoint: {
			name: function name(layer) {
				return layer.type.name;
			},
			content: function content(layer, feature) {
				var station = layer.getUuid().find(function (el) {
					return el.uuid === feature.id;
				}).obj;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						station.code,
						' '
					),
					':',
					_react2.default.createElement('br', null),
					feature.name
				);
			}
		},
		popupKmlCity: {
			name: function name(layer, feature) {
				return feature.NAME;
			},
			content: function content(layer, feature) {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						feature.NAME
					),
					_react2.default.createElement('br', null),
					'Code postal : ',
					feature.CODE_POSTAL,
					_react2.default.createElement('br', null),
					'Population : ',
					feature.POPULATION,
					_react2.default.createElement('br', null),
					'D\xE9partement : ',
					feature.CODE_DEPARTMENT,
					_react2.default.createElement('br', null)
				);
			}
		},
		popupKmlWaterSheed: {
			name: function name(layer, feature) {
				return feature.CODE;
			}, content: function content(layer, feature) {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						feature.CODE
					),
					_react2.default.createElement('br', null),
					'Nom : ',
					feature.NAME,
					_react2.default.createElement('br', null)
				);
			}
		}
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _openlayers = __webpack_require__(80);

	var _openlayers2 = _interopRequireDefault(_openlayers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var fillBlack = function fillBlack() {
		var fill = new _openlayers2.default.style.Fill({
			color: _openlayers2.default.color.asString('rgba(255,255,255,0.5)')
		});
		var stroke = new _openlayers2.default.style.Stroke({
			color: _openlayers2.default.color.asString('#000000'),
			width: 2
		});
		return [new _openlayers2.default.style.Style({
			fill: fill,
			stroke: stroke
		})];
	};

	var fillRed = function fillRed() {
		var fill = new _openlayers2.default.style.Fill({
			color: _openlayers2.default.color.asString('rgba(255,255,255,0.3)')
		});
		var stroke = new _openlayers2.default.style.Stroke({
			color: _openlayers2.default.color.asString('#ff0000'),
			width: 2
		});
		return [new _openlayers2.default.style.Style({
			fill: fill,
			stroke: stroke
		})];
	};

	exports.default = {
		FILL_RED: fillRed(),
		FILL_BLACK: fillBlack()
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.default = Custom;

	var _ILayers = __webpack_require__(86);

	var _ILayers2 = _interopRequireDefault(_ILayers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Custom = function (_Layers) {
		_inherits(_Custom, _Layers);

		function _Custom(vector) {
			_classCallCheck(this, _Custom);

			var _this = _possibleConstructorReturn(this, (_Custom.__proto__ || Object.getPrototypeOf(_Custom)).call(this));

			_this.vector = vector;
			return _this;
		}

		_createClass(_Custom, [{
			key: 'getLayer',
			value: function getLayer() {
				return this.vector;
			}
		}]);

		return _Custom;
	}(_ILayers2.default);

	function Custom() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return new (Function.prototype.bind.apply(_Custom, [null].concat(args)))();
	}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _MapException = __webpack_require__(87);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ILayers = function () {
		function ILayers() {
			_classCallCheck(this, ILayers);

			this.uuid = [];
			if (!this.getLayer) {
				throw new _MapException.MapException('getLayer is not defined');
			}
		}

		_createClass(ILayers, [{
			key: 'generateUUID',
			value: function generateUUID() {
				var d = new Date().getTime();
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (d + Math.random() * 16) % 16 | 0;
					d = Math.floor(d / 16);
					return function () {
						if (c === 'x') {
							return r;
						}
						return r & 0x3 | 0x8;
					}().toString(16);
				});
				return uuid;
			}
		}, {
			key: 'getUuid',
			value: function getUuid() {
				return this.uuid;
			}
		}, {
			key: 'getPopup',
			value: function getPopup() {
				return '';
			}
		}, {
			key: 'checkUuid',
			value: function checkUuid(u) {
				return !!this.uuid.find(function (el) {
					return u === el.uuid;
				});
			}
		}, {
			key: 'registerFeature',
			value: function registerFeature() {
				var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

				var uuid = this.generateUUID();
				this.uuid.push({ uuid: uuid, obj: obj });
				return uuid;
			}
		}]);

		return ILayers;
	}();

	exports.default = ILayers;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var MapException = function (_Error) {
		_inherits(MapException, _Error);

		function MapException(message) {
			_classCallCheck(this, MapException);

			var name = 'MapException';

			var _this = _possibleConstructorReturn(this, (MapException.__proto__ || Object.getPrototypeOf(MapException)).call(this, name + ' : ' + message));

			_this.name = name;
			return _this;
		}

		return MapException;
	}(Error);

	exports.MapException = MapException;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.default = KML;

	var _ILayers = __webpack_require__(86);

	var _ILayers2 = _interopRequireDefault(_ILayers);

	var _ActionUtils = __webpack_require__(89);

	var _openlayers = __webpack_require__(80);

	var _openlayers2 = _interopRequireDefault(_openlayers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _KML = function (_Layers) {
	    _inherits(_KML, _Layers);

	    function _KML(obj) {
	        _classCallCheck(this, _KML);

	        var _this = _possibleConstructorReturn(this, (_KML.__proto__ || Object.getPrototypeOf(_KML)).call(this));

	        _this.obj = obj;
	        _this.kmlFormatWater = new _openlayers2.default.format.KML({
	            extractStyles: obj.extractStyles || false
	        });
	        _this.type = obj.type || {};
	        _this.popup = obj.popup;
	        _this.layer = _this.createLayer();
	        return _this;
	    }

	    _createClass(_KML, [{
	        key: 'getHeaders',
	        value: function getHeaders() {
	            if (this.obj.headers) {
	                return { Accept: 'application/vnd.google-earth.kml+xml' };
	            }
	            return {};
	        }
	    }, {
	        key: 'createLayer',
	        value: function createLayer() {
	            var that = this;
	            var vct = new _openlayers2.default.source.Vector({
	                loader: function loader() {
	                    fetch(that.obj.url, {
	                        headers: that.getHeaders(),
	                        method: 'GET'
	                    }).then(function (response) {
	                        return (0, _ActionUtils.checkStatus)({
	                            200: function _(rep) {
	                                return rep.text();
	                            },
	                            204: function _() {
	                                return [];
	                            }
	                        }, response);
	                    }).then(function () {
	                        var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	                        var feature = that.kmlFormatWater.readFeatures(response, { featureProjection: 'EPSG:3857' });
	                        feature.map(function (f) {
	                            return f.setId(that.registerFeature());
	                        });
	                        vct.addFeatures(feature);
	                    });
	                },
	                format: this.kmlFormatWater
	            });

	            return new _openlayers2.default.layer.Vector({
	                source: vct,
	                style: this.obj.style
	            });
	        }
	    }, {
	        key: 'getLayer',
	        value: function getLayer() {
	            return this.layer;
	        }
	    }, {
	        key: 'getPopup',
	        value: function getPopup() {
	            return this.popup;
	        }
	    }]);

	    return _KML;
	}(_ILayers2.default);

	function KML(args) {
	    return new _KML(args);
	}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var checkAuth = function checkAuth(response) {
		switch (response.status) {
			case 200:
				return response;
			case 403:
				throw new Error('Not Authorized');
			case 500:
				throw new Error('Unable to contact service');
			default:
				throw new Error('Not Authorized');
		}
	};

	var getJson = function getJson(response) {
		return response.json();
	};

	var checkStatus = function checkStatus(obj, response) {
		var code = Object.keys(obj).find(function (element) {
			return response.status + '' === element + '';
		});
		if (!code) {
			throw new Error('Unhandled Error during fetch' + response.status);
		}
		return obj[code](response);
	};

	exports.checkAuth = checkAuth;
	exports.getJson = getJson;
	exports.checkStatus = checkStatus;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.default = OSM;

	var _ILayers = __webpack_require__(86);

	var _ILayers2 = _interopRequireDefault(_ILayers);

	var _openlayers = __webpack_require__(80);

	var _openlayers2 = _interopRequireDefault(_openlayers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _OSM = function (_Layers) {
		_inherits(_OSM, _Layers);

		function _OSM() {
			_classCallCheck(this, _OSM);

			var _this = _possibleConstructorReturn(this, (_OSM.__proto__ || Object.getPrototypeOf(_OSM)).call(this));

			_this.layer = _this.createLayer();
			return _this;
		}

		_createClass(_OSM, [{
			key: 'createLayer',
			value: function createLayer() {
				return new _openlayers2.default.layer.Tile({
					source: new _openlayers2.default.source.OSM()
				});
			}
		}, {
			key: 'getLayer',
			value: function getLayer() {
				return this.layer;
			}
		}]);

		return _OSM;
	}(_ILayers2.default);

	function OSM() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return new (Function.prototype.bind.apply(_OSM, [null].concat(args)))();
	}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.default = SingleStationPoint;

	var _ILayers = __webpack_require__(86);

	var _ILayers2 = _interopRequireDefault(_ILayers);

	var _openlayers = __webpack_require__(80);

	var _openlayers2 = _interopRequireDefault(_openlayers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _SingleStationPoint = function (_Layers) {
		_inherits(_SingleStationPoint, _Layers);

		function _SingleStationPoint(obj) {
			_classCallCheck(this, _SingleStationPoint);

			var _this = _possibleConstructorReturn(this, (_SingleStationPoint.__proto__ || Object.getPrototypeOf(_SingleStationPoint)).call(this));

			_this.type = obj.type;
			_this.objPoints = obj;
			_this.layer = _this.createLayer();
			return _this;
		}

		_createClass(_SingleStationPoint, [{
			key: 'createLayer',
			value: function createLayer() {
				var feature = this.createFeature(this.objPoints.site.site.localization.xCoordinate, this.objPoints.site.site.localization.yCoordinate, this.objPoints.type.img, this.objPoints.site.site.name, this.objPoints.site.site);
				var vectorSource = new _openlayers2.default.source.Vector({
					features: [feature]
				});

				return new _openlayers2.default.layer.Vector({
					source: vectorSource
				});
			}
		}, {
			key: 'getLayer',
			value: function getLayer() {
				return this.layer;
			}
		}, {
			key: 'createFeature',
			value: function createFeature(x, y, style, name, site) {
				var f = new _openlayers2.default.Feature({
					geometry: new _openlayers2.default.geom.Point(_openlayers2.default.proj.transform([+x, +y], 'EPSG:4326', 'EPSG:3857')),
					name: name
				});
				f.setId(this.registerFeature(site));
				f.setStyle(style);
				return f;
			}
		}]);

		return _SingleStationPoint;
	}(_ILayers2.default);

	function SingleStationPoint() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return new (Function.prototype.bind.apply(_SingleStationPoint, [null].concat(args)))();
	}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.default = SitesPoint;

	var _ILayers = __webpack_require__(86);

	var _ILayers2 = _interopRequireDefault(_ILayers);

	var _openlayers = __webpack_require__(80);

	var _openlayers2 = _interopRequireDefault(_openlayers);

	var _CoordinateUtils = __webpack_require__(93);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _SitesPoint = function (_Layers) {
	    _inherits(_SitesPoint, _Layers);

	    function _SitesPoint(obj) {
	        _classCallCheck(this, _SitesPoint);

	        var _this = _possibleConstructorReturn(this, (_SitesPoint.__proto__ || Object.getPrototypeOf(_SitesPoint)).call(this));

	        _this.type = obj.type;
	        _this.objPoints = obj;
	        _this.popup = obj.popup;
	        _this.layer = _this.createLayer();
	        return _this;
	    }

	    _createClass(_SitesPoint, [{
	        key: 'createLayer',
	        value: function createLayer() {
	            var _this2 = this;

	            var features = this.objPoints.site.map(function (point) {
	                return _this2.createFeature(point.xCoordinate, point.yCoordinate, point.projection, _this2.objPoints.type.img, point.name, point);
	            });

	            var vectorSource = new _openlayers2.default.source.Vector({
	                features: features
	            });

	            return new _openlayers2.default.layer.Vector({
	                source: vectorSource
	            });
	        }
	    }, {
	        key: 'getLayer',
	        value: function getLayer() {
	            return this.layer;
	        }
	    }, {
	        key: 'createFeature',
	        value: function createFeature(x, y, projection, style, name, site) {
	            var center = (0, _CoordinateUtils.getWGS84Coordinate)(x, y, projection);
	            var f = new _openlayers2.default.Feature({
	                geometry: new _openlayers2.default.geom.Point(_openlayers2.default.proj.transform(center, 'EPSG:4326', 'EPSG:3857')),
	                name: name
	            });
	            f.setId(this.registerFeature(site));
	            f.setStyle(style);
	            return f;
	        }
	    }, {
	        key: 'getPopup',
	        value: function getPopup() {
	            return this.popup;
	        }
	    }]);

	    return _SitesPoint;
	}(_ILayers2.default);

	function SitesPoint() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	    }

	    return new (Function.prototype.bind.apply(_SitesPoint, [null].concat(args)))();
	}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getWGS84Coordinate = undefined;

	var _proj = __webpack_require__(94);

	var _proj2 = _interopRequireDefault(_proj);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var getWGS84Coordinate = function getWGS84Coordinate(x, y, projection) {
	    if (projection) {
	        switch (projection) {
	            case 2:
	                return (0, _proj2.default)('+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs', 'WGS84', [+x, +y]);
	            case 5:
	                return (0, _proj2.default)('+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs', 'WGS84', [+x, +y]);
	            case 26:
	                return (0, _proj2.default)('+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs', 'WGS84', [+x, +y]);
	            case 16:
	                return [+x, +y];
	            case 0:
	                return [2.4983333333333335, 46.6058333];
	            default:
	                return (0, _proj2.default)('+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs', 'WGS84', [+x, +y]);
	        }
	    }
	    // return proj4('+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs', 'WGS84', [+x, +y])
	    return (0, _proj2.default)('+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs ', 'WGS84', [+x, +y]);
	};

	exports.getWGS84Coordinate = getWGS84Coordinate;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = require("proj4");

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.default = StationPoint;

	var _ILayers = __webpack_require__(86);

	var _ILayers2 = _interopRequireDefault(_ILayers);

	var _openlayers = __webpack_require__(80);

	var _openlayers2 = _interopRequireDefault(_openlayers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _StationPoint = function (_Layers) {
		_inherits(_StationPoint, _Layers);

		function _StationPoint(obj) {
			_classCallCheck(this, _StationPoint);

			var _this = _possibleConstructorReturn(this, (_StationPoint.__proto__ || Object.getPrototypeOf(_StationPoint)).call(this));

			_this.type = obj.type;
			_this.objPoints = obj;
			_this.popup = obj.popup;
			_this.layer = _this.createLayer();
			return _this;
		}

		_createClass(_StationPoint, [{
			key: 'createLayer',
			value: function createLayer() {
				var _this2 = this;

				console.log(this.objPoints.site);
				var features = this.objPoints.site.map(function (point) {
					return _this2.createFeature(point.latitude, point.longitude, _this2.objPoints.type.img, point.name, point);
				});

				var vectorSource = new _openlayers2.default.source.Vector({
					features: features
				});

				return new _openlayers2.default.layer.Vector({
					source: vectorSource
				});
			}
		}, {
			key: 'getLayer',
			value: function getLayer() {
				return this.layer;
			}
		}, {
			key: 'createFeature',
			value: function createFeature(x, y, style, name, site) {
				var f = new _openlayers2.default.Feature({
					geometry: new _openlayers2.default.geom.Point(_openlayers2.default.proj.transform([+x, +y], 'EPSG:4326', 'EPSG:3857')),
					name: name
				});
				f.setId(this.registerFeature(site));
				f.setStyle(style);
				return f;
			}
		}, {
			key: 'getPopup',
			value: function getPopup() {
				return this.popup;
			}
		}]);

		return _StationPoint;
	}(_ILayers2.default);

	function StationPoint() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return new (Function.prototype.bind.apply(_StationPoint, [null].concat(args)))();
	}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.default = WMS;

	var _ILayers = __webpack_require__(86);

	var _ILayers2 = _interopRequireDefault(_ILayers);

	var _openlayers = __webpack_require__(80);

	var _openlayers2 = _interopRequireDefault(_openlayers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _WMS = function (_Layers) {
		_inherits(_WMS, _Layers);

		function _WMS(obj) {
			_classCallCheck(this, _WMS);

			var _this = _possibleConstructorReturn(this, (_WMS.__proto__ || Object.getPrototypeOf(_WMS)).call(this));

			_this.url = obj.url;
			_this.params = obj.params;
			_this.layer = _this.createLayer();
			return _this;
		}

		_createClass(_WMS, [{
			key: 'createLayer',
			value: function createLayer() {
				return new _openlayers2.default.layer.Tile({
					source: new _openlayers2.default.source.TileWMS({
						url: this.url,
						params: this.params
					})
				});
			}
		}, {
			key: 'getLayer',
			value: function getLayer() {
				return this.layer;
			}
		}]);

		return _WMS;
	}(_ILayers2.default);

	function WMS() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return new (Function.prototype.bind.apply(_WMS, [null].concat(args)))();
	}

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/react-aquasys/dist/bundle.js
// module id = 49
// module chunks = 0